
function parseCsvRows(csvText) {
  var rows = [];
  var row = [];
  var value = '';
  var inQuotes = false;

  for (var i = 0; i < csvText.length; i++) {
    var char = csvText[i];
    var next = csvText[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        value += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === ',' && !inQuotes) {
      row.push(value);
      value = '';
    } else if ((char === '\n' || char === '\r') && !inQuotes) {
      if (char === '\r' && next === '\n') i++;
      row.push(value);
      if (row.length > 1 || row[0] !== '') rows.push(row);
      row = [];
      value = '';
    } else {
      value += char;
    }
  }

  if (value.length || row.length) {
    row.push(value);
    rows.push(row);
  }

  if (!rows.length) return [];

  var headers = rows[0];
  return rows.slice(1).map(function (cols) {
    var obj = {};
    headers.forEach(function (header, index) {
      obj[String(header || '').trim()] = String(cols[index] || '').trim();
    });
    return obj;
  });
}

function normalizeFieldName(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/^metafield:\s*/i, '')
    .replace(/^custom\./i, '')
    .replace(/^species\./i, '')
    .replace(/[\s\-\/]+/g, '_')
    .replace(/[^\w]/g, '')
    .trim();
}

function getRowValue(row, keys) {
  if (!row) return '';

  var normalizedMap = {};
  Object.keys(row).forEach(function (key) {
    normalizedMap[normalizeFieldName(key)] = row[key];
  });

  for (var i = 0; i < keys.length; i++) {
    var direct = row[keys[i]];
    if (direct != null && String(direct).trim() !== '') return String(direct).trim();

    var normalized = normalizedMap[normalizeFieldName(keys[i])];
    if (normalized != null && String(normalized).trim() !== '') return String(normalized).trim();
  }

  return '';
}

function clampNumber(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function textHasAny(text, phrases) {
  var hay = String(text || '').toLowerCase();
  return phrases.some(function (phrase) {
    return hay.indexOf(String(phrase).toLowerCase()) !== -1;
  });
}

function buildComparePayloadFromRow(row) {
  var title = getRowValue(row, [
    'Metafield: custom.species_common_name',
    'custom.species_common_name',
    'species_common_name',
    'common_name',
    'title'
  ]);

  var scientificName = getRowValue(row, [
    'Metafield: custom.species_scientific_name',
    'custom.species_scientific_name',
    'species_scientific_name',
    'scientific_name'
  ]);

  var guideUrl = getRowValue(row, [
    'guide_url',
    'Guide URL',
    'url',
    'article_url'
  ]);

  var imageUrl = getRowValue(row, [
  'image',
  'image_url',
  'Image URL',
  'featured_image',
  'article_image'
]);

  var behaviorJson = getRowValue(row, ['behavior_json']);
  var strikeJson = getRowValue(row, ['strike_json']);
  var habitatJson = getRowValue(row, ['habitat_json']);
  var fightJson = getRowValue(row, ['fight_json']);

  if (behaviorJson && strikeJson && habitatJson && fightJson) {
    try {
      return {
        title: title,
        scientific_name: scientificName,
        url: guideUrl,
        handle: getRowValue(row, ['handle', 'Handle', 'article_handle']) || guideUrl || title,
        image: imageUrl,
        comparison_copy: {
          headlines: [],
          summaries: [],
          primary_implications: [],
          compare_implications: []
        },
        behavior: JSON.parse(behaviorJson),
        strike: JSON.parse(strikeJson),
        habitat: JSON.parse(habitatJson),
        fight: JSON.parse(fightJson)
      };
    } catch (error) {
      console.error('Precomputed compare JSON parse failed', error);
    }
  }

  var habitat = getRowValue(row, [
    'Metafield: custom.species_habitat',
    'custom.species_habitat',
    'species_habitat',
    'habitat'
  ]);

  var bestTech = getRowValue(row, [
    'Metafield: custom.species_best_techniques',
    'custom.species_best_techniques',
    'species_best_techniques',
    'best_techniques'
  ]);

  var bestBaits = getRowValue(row, [
    'Metafield: custom.species_best_baits',
    'custom.species_best_baits',
    'species_best_baits',
    'best_baits'
  ]);

  var description = getRowValue(row, [
    'Metafield: custom.species_description',
    'custom.species_description',
    'species_description',
    'description'
  ]);

  var challengeScoreRaw = getRowValue(row, [
    'Metafield: custom.challenge_score',
    'custom.challenge_score',
    'challenge_score'
  ]);

  var challengeScore = clampNumber(parseFloat(challengeScoreRaw || '0') || 0, 0, 100);
  var commandText = [habitat, bestTech, bestBaits, description].join(' ').toLowerCase();

  var coverScore = 35;
  if (textHasAny(commandText, ['structure'])) coverScore += 18;
  if (textHasAny(commandText, ['cover'])) coverScore += 16;
  if (textHasAny(commandText, ['weed', 'weeds', 'grass'])) coverScore += 12;
  if (textHasAny(commandText, ['rock', 'boulder', 'reef'])) coverScore += 10;
  if (textHasAny(commandText, ['wood', 'timber', 'laydown', 'dock'])) coverScore += 10;
  if (textHasAny(commandText, ['undercut', 'bank'])) coverScore += 8;
  if (textHasAny(commandText, ['open water', 'pelagic', 'schooling', 'roam', 'roving'])) coverScore -= 20;
  coverScore = clampNumber(coverScore, 0, 100);

  var behaviorAggression = challengeScore * 0.4 + 30;
  if (textHasAny(commandText, ['aggressive', 'chase', 'predator', 'ambush', 'reaction', 'violent'])) behaviorAggression += 20;
  if (textHasAny(commandText, ['topwater', 'jerkbait', 'swimbait', 'burn', 'rip', 'fast retrieve'])) behaviorAggression += 10;
  if (textHasAny(commandText, ['sharp teeth', 'toothy', 'barracuda'])) behaviorAggression += 10;
  if (textHasAny(commandText, ['scavenger', 'graze', 'grazing', 'detritus', 'plankton'])) behaviorAggression -= 20;
  if (textHasAny(commandText, ['slow presentation', 'passive feeder', 'cautious feeder'])) behaviorAggression -= 10;
  behaviorAggression = clampNumber(behaviorAggression, 0, 100);

  var behaviorWariness = 40;
  if (textHasAny(commandText, ['clear water', 'spooky', 'wary', 'selective'])) behaviorWariness += 20;
  if (textHasAny(commandText, ['finesse', 'stealth', 'pressured', 'natural presentation', 'presentation'])) behaviorWariness += 10;
  if (textHasAny(commandText, ['schooling', 'feeding frenzy', 'pelagic', 'open water'])) behaviorWariness -= 10;
  behaviorWariness = clampNumber(behaviorWariness, 0, 100);

  var behaviorFight = challengeScore * 0.6 + 25;
  if (textHasAny(commandText, ['powerful', 'strong', 'hard fight', 'violent fight'])) behaviorFight += 15;
  if (textHasAny(commandText, ['acrobatic', 'jumps', 'jumping'])) behaviorFight += 10;
  if (textHasAny(commandText, ['long runs', 'runs hard', 'stamina'])) behaviorFight += 10;
  if (textHasAny(commandText, ['weak fight', 'minimal resistance', 'short fight'])) behaviorFight -= 15;
  behaviorFight = clampNumber(behaviorFight, 0, 100);

  var behaviorStructure = clampNumber(coverScore, 0, 100);

  var behaviorRoaming = 35;
  if (textHasAny(commandText, ['roam', 'roving', 'patrol', 'cruise', 'cruising'])) behaviorRoaming += 20;
  if (textHasAny(commandText, ['pelagic', 'open water', 'migratory', 'migration'])) behaviorRoaming += 20;
  if (textHasAny(commandText, ['schooling', 'bait ball', 'bait balls', 'chasing bait'])) behaviorRoaming += 10;
  if (textHasAny(commandText, ['ambush', 'holds tight', 'territorial'])) behaviorRoaming -= 15;
  if (coverScore >= 70) behaviorRoaming -= 10;
  if (coverScore <= 35) behaviorRoaming += 10;
  behaviorRoaming = clampNumber(behaviorRoaming, 0, 100);

  var behaviorSurface = 20;
  if (textHasAny(commandText, ['surface', 'topwater', 'wake bait', 'rises', 'rising', 'boils', 'busting'])) behaviorSurface += 30;
  if (textHasAny(commandText, ['dry fly', 'dry flies'])) behaviorSurface += 28;
  if (textHasAny(commandText, ['baitfish blitz', 'blitz'])) behaviorSurface += 20;
  if (textHasAny(commandText, ['bottom feeder', 'benthic', 'deep jigging'])) behaviorSurface -= 10;
  behaviorSurface = clampNumber(behaviorSurface, 0, 100);

  var behaviorSchooling = 20;
  if (textHasAny(commandText, ['schooling', 'schools', 'school', 'pods', 'shoals'])) behaviorSchooling += 40;
  if (textHasAny(commandText, ['pelagic'])) behaviorSchooling += 20;
  if (textHasAny(commandText, ['bait balls', 'bait ball'])) behaviorSchooling += 20;
  if (textHasAny(commandText, ['solitary', 'territorial', 'lone predator', 'ambush predator'])) behaviorSchooling -= 20;
  behaviorSchooling = clampNumber(behaviorSchooling, 0, 100);

  var behaviorFeedingWindows = 45;
  if (textHasAny(commandText, ['dawn', 'dusk', 'low light', 'night'])) behaviorFeedingWindows += 15;
  if (textHasAny(commandText, ['tide', 'current', 'moon phase', 'moon'])) behaviorFeedingWindows += 20;
  if (textHasAny(commandText, ['front', 'weather', 'temperature', 'water temp'])) behaviorFeedingWindows += 10;
  if (textHasAny(commandText, ['all day', 'throughout the day', 'steady feeder', 'consistently'])) behaviorFeedingWindows -= 15;
  behaviorFeedingWindows = clampNumber(behaviorFeedingWindows, 0, 100);

  var strikeTrigger = 45;
  if (textHasAny(commandText, ['reaction', 'chase', 'topwater', 'jerkbait', 'rip', 'burn', 'flash', 'vibration'])) strikeTrigger += 20;
  if (textHasAny(commandText, ['aggressive feeder', 'violent strike', 'trigger bite'])) strikeTrigger += 10;
  if (textHasAny(commandText, ['slow', 'finesse', 'deadstick', 'inspect', 'cautious feeder'])) strikeTrigger -= 15;
  strikeTrigger = clampNumber(strikeTrigger, 0, 100);

  var strikeSelectivity = 40;
  if (textHasAny(commandText, ['selective', 'clear water', 'match the hatch', 'natural presentation', 'pressured', 'finesse'])) strikeSelectivity += 20;
  if (challengeScore >= 65) strikeSelectivity += 10;
  if (textHasAny(commandText, ['opportunistic', 'feeding frenzy', 'aggressive feeder', 'broad forage'])) strikeSelectivity -= 15;
  strikeSelectivity = clampNumber(strikeSelectivity, 0, 100);

  var strikeSpeed = 40;
  if (textHasAny(commandText, ['fast', 'explosive', 'quick strike', 'chase', 'moving water', 'current'])) strikeSpeed += 20;
  if (textHasAny(commandText, ['jerkbait', 'burn', 'rip', 'reaction'])) strikeSpeed += 10;
  if (textHasAny(commandText, ['slow', 'deliberate', 'inspect', 'mouthing bait'])) strikeSpeed -= 15;
  strikeSpeed = clampNumber(strikeSpeed, 0, 100);

  var strikeCommitment = 45;
  if (textHasAny(commandText, ['crush', 'hammer', 'engulf', 'hard hit', 'violent strike'])) strikeCommitment += 20;
  if (textHasAny(commandText, ['fully commits', 'pins the bait'])) strikeCommitment += 10;
  if (textHasAny(commandText, ['peck', 'nip', 'short strike', 'light bite', 'slap'])) strikeCommitment -= 20;
  strikeCommitment = clampNumber(strikeCommitment, 0, 100);

  var strikePrecision = 45;
  if (textHasAny(commandText, ['exact depth', 'drift', 'cadence', 'natural presentation', 'match the hatch', 'finesse'])) strikePrecision += 20;
  if (challengeScore >= 60) strikePrecision += 10;
  if (textHasAny(commandText, ['reaction bite', 'aggressive feeder', 'broad retrieve tolerance'])) strikePrecision -= 15;
  strikePrecision = clampNumber(strikePrecision, 0, 100);

  var strikeStealth = 35;
  if (textHasAny(commandText, ['stealth', 'spooky', 'clear water', 'pressured', 'boat shy', 'wary'])) strikeStealth += 20;
  if (challengeScore >= 65) strikeStealth += 10;
  if (textHasAny(commandText, ['dirty water', 'aggressive feed mode', 'tolerant of disturbance', 'pelagic'])) strikeStealth -= 15;
  strikeStealth = clampNumber(strikeStealth, 0, 100);

  var strikeReaction = 40;
  if (textHasAny(commandText, ['reaction strike', 'jerkbait', 'ripping', 'ambush', 'topwater', 'trigger bite'])) strikeReaction += 20;
  if (textHasAny(commandText, ['burn', 'rip', 'flash'])) strikeReaction += 10;
  if (textHasAny(commandText, ['inspect', 'finesse', 'slow eat', 'forage match'])) strikeReaction -= 15;
  strikeReaction = clampNumber(strikeReaction, 0, 100);

  var strikeOpportunism = 45;
  if (textHasAny(commandText, ['opportunistic', 'broad forage', 'scavenger', 'aggressive feeder', 'bait availability', 'wide range'])) strikeOpportunism += 20;
  if (textHasAny(commandText, ['selective', 'forage specific', 'match the hatch', 'exact prey preference'])) strikeOpportunism -= 20;
  strikeOpportunism = clampNumber(strikeOpportunism, 0, 100);

     var habitatStructure = 42;
  if (textHasAny(commandText, ['structure', 'reef', 'rock', 'rocks', 'boulder', 'riprap', 'dock', 'bridge', 'timber', 'wood', 'laydown', 'ledge', 'drop-off', 'drop off'])) habitatStructure += 24;
  if (textHasAny(commandText, ['pelagic', 'open water', 'blue water'])) habitatStructure -= 24;
  habitatStructure = clampNumber(habitatStructure, 0, 100);

  var habitatDepth = 45;
  if (textHasAny(commandText, ['deep', 'depth', 'bottom', 'benthic', 'offshore', 'drop shot', 'deep jigging'])) habitatDepth += 24;
  if (textHasAny(commandText, ['surface', 'shallow', 'skinny water', 'flats', 'topwater'])) habitatDepth -= 18;
  habitatDepth = clampNumber(habitatDepth, 0, 100);

  var habitatCover = 40;
  if (textHasAny(commandText, ['cover', 'weed', 'weeds', 'grass', 'vegetation', 'mangrove', 'mangroves', 'timber', 'wood', 'dock', 'wreck', 'wrecks'])) habitatCover += 26;
  if (textHasAny(commandText, ['open water', 'pelagic', 'blue water'])) habitatCover -= 22;
  habitatCover = clampNumber(habitatCover, 0, 100);

  var habitatRoaming = 42;
  if (textHasAny(commandText, ['roam', 'roving', 'patrol', 'cruise', 'cruising', 'migratory', 'migration', 'pelagic', 'schooling'])) habitatRoaming += 24;
  if (textHasAny(commandText, ['ambush', 'holds tight', 'holds near', 'sets up', 'territorial'])) habitatRoaming -= 18;
  habitatRoaming = clampNumber(habitatRoaming, 0, 100);

  var habitatCurrent = 34;
  if (textHasAny(commandText, ['current', 'flow', 'tide', 'moving water', 'seam', 'river', 'stream', 'drift'])) habitatCurrent += 28;
  if (textHasAny(commandText, ['lake', 'pond', 'still water'])) habitatCurrent -= 10;
  habitatCurrent = clampNumber(habitatCurrent, 0, 100);

  var habitatAmbush = 38;
  if (textHasAny(commandText, ['ambush', 'ambush predator', 'edge', 'shadow', 'cover', 'structure oriented', 'holds tight'])) habitatAmbush += 28;
  if (textHasAny(commandText, ['chase', 'chasing bait', 'open water', 'schooling', 'pelagic'])) habitatAmbush -= 18;
  habitatAmbush = clampNumber(habitatAmbush, 0, 100);

  var habitatZoneSpec = 44;
  if (textHasAny(commandText, ['specific depth', 'depth band', 'precise', 'edge', 'seam', 'channel edge', 'breakline', 'structure'])) habitatZoneSpec += 22;
  if (textHasAny(commandText, ['widely distributed', 'throughout the water column', 'open water', 'roams widely'])) habitatZoneSpec -= 18;
  habitatZoneSpec = clampNumber(habitatZoneSpec, 0, 100);

  var habitatVertical = 36;
  if (textHasAny(commandText, ['suspended', 'water column', 'rises', 'rising', 'surface', 'drops', 'vertical'])) habitatVertical += 26;
  if (textHasAny(commandText, ['bottom dweller', 'benthic', 'holds bottom', 'bottom-oriented'])) habitatVertical -= 16;
  habitatVertical = clampNumber(habitatVertical, 0, 100);

   var fightNameText = (title + ' ' + scientificName).toLowerCase();

  var isTinyFish = textHasAny(fightNameText, [
    'shiner', 'minnow', 'anchovy', 'sardine', 'silverside',
    'killifish', 'smelt', 'goby', 'blenny', 'dace', 'shad'
  ]);

  var isPanfish = textHasAny(fightNameText, [
    'bluegill', 'sunfish', 'crappie', 'perch', 'pumpkinseed', 'redear', 'rock bass'
  ]);

  var isBassLike = textHasAny(fightNameText, [
    'largemouth bass', 'smallmouth bass', 'spotted bass', 'bass'
  ]);

  var isPelagicSpeedster = textHasAny(fightNameText, [
    'tuna', 'skipjack', 'bonito', 'albacore', 'wahoo', 'mahi', 'dolphinfish',
    'king mackerel', 'kingfish', 'mackerel', 'trevally', 'jack', 'false albacore', 'barracuda'
  ]);

  var isBulldog = textHasAny(fightNameText, [
    'grouper', 'amberjack', 'sturgeon', 'catfish', 'drum', 'black drum',
    'blue catfish', 'flathead', 'halibut'
  ]);

  var isJumper = textHasAny(fightNameText, [
    'tarpon', 'salmon', 'steelhead', 'sailfish', 'marlin', 'trout', 'mahi', 'snook'
  ]);

  var isSharkLike = textHasAny(fightNameText, [
    'shark', 'ray', 'skate'
  ]);

  var isGiantFish = textHasAny(fightNameText, [
    'whale shark', 'basking shark', 'bluefin tuna', 'giant trevally', 'marlin', 'sailfish'
  ]);

  var fightMassClass = 3;

  if (isTinyFish) {
    fightMassClass = 1;
  } else if (isPanfish) {
    fightMassClass = 2;
  } else if (isBassLike) {
    fightMassClass = 3;
  } else if (isPelagicSpeedster || isBulldog || isSharkLike) {
    fightMassClass = 4;
  }

  if (challengeScore >= 75) {
    fightMassClass += 1;
  } else if (challengeScore <= 15) {
    fightMassClass -= 1;
  }

  if (isGiantFish) {
    fightMassClass = 6;
  }

  fightMassClass = clampNumber(fightMassClass, 1, 6);

  var fightRunPower = [0, 6, 14, 30, 50, 72, 90][fightMassClass];
  if (isPelagicSpeedster) fightRunPower += 18;
  if (isSharkLike) fightRunPower += 10;
  if (isBassLike) fightRunPower -= 2;
  if (textHasAny(commandText, ['powerful', 'strong', 'explosive', 'runs hard', 'initial run'])) fightRunPower += 10;
  if (isTinyFish) fightRunPower = Math.min(fightRunPower, 12);
  if (isPanfish) fightRunPower = Math.min(fightRunPower, 20);
  fightRunPower = clampNumber(fightRunPower, 0, 100);

  var fightEndurance = [0, 8, 16, 30, 46, 66, 84][fightMassClass];
  if (isPelagicSpeedster) fightEndurance += 16;
  if (isBulldog) fightEndurance += 10;
  if (isJumper) fightEndurance += 6;
  if (textHasAny(commandText, ['stamina', 'endurance', 'long fight', 'long runs', 'sustained fight'])) fightEndurance += 14;
  if (fightRunPower >= 70) fightEndurance += 8;
  if (isTinyFish) fightEndurance = Math.min(fightEndurance, 14);
  if (isPanfish) fightEndurance = Math.min(fightEndurance, 24);
  fightEndurance = clampNumber(fightEndurance, 0, 100);

  var fightChaos = 18;
  if (isJumper) fightChaos += 18;
  if (isBassLike) fightChaos += 8;
  if (textHasAny(commandText, ['erratic', 'violent', 'chaotic', 'head shakes', 'surges'])) fightChaos += 24;
  if (isTinyFish) fightChaos -= 8;
  fightChaos = clampNumber(fightChaos, 0, 100);

  var fightAerial = 6;
  if (isJumper) fightAerial += 36;
  if (textHasAny(commandText, ['jumps', 'jumping', 'acrobatic', 'aerial', 'airborne'])) fightAerial += 36;
  if (isBulldog || isSharkLike) fightAerial -= 6;
  fightAerial = clampNumber(fightAerial, 0, 100);

  var fightLineStress = [0, 5, 12, 28, 48, 70, 90][fightMassClass];
  if (isPelagicSpeedster) fightLineStress += 12;
  if (isSharkLike) fightLineStress += 10;
  if (textHasAny(commandText, ['heavy tackle', 'light line', 'break off', 'tackle stress', 'line-shy but powerful'])) fightLineStress += 14;
  if (isTinyFish) fightLineStress = Math.min(fightLineStress, 10);
  if (isPanfish) fightLineStress = Math.min(fightLineStress, 18);
  fightLineStress = clampNumber(fightLineStress, 0, 100);

  var fightLanding = [0, 6, 14, 28, 46, 66, 86][fightMassClass];
  if (habitatStructure >= 65) fightLanding += 8;
  if (habitatCover >= 65) fightLanding += 8;
  if (isBulldog) fightLanding += 10;
  if (isJumper) fightLanding += 8;
  if (textHasAny(commandText, ['hard to land', 'difficult to land', 'boat side', 'last-minute surge', 'notorious for throwing hooks'])) fightLanding += 14;
  if (isTinyFish) fightLanding = Math.min(fightLanding, 12);
  fightLanding = clampNumber(fightLanding, 0, 100);

  var fightRecovery = 12;
  if (isBulldog) fightRecovery += 16;
  if (isPelagicSpeedster) fightRecovery += 10;
  if (textHasAny(commandText, ['second run', 'surges again', 'last-minute burst', 'repeated runs', 'digging again'])) fightRecovery += 24;
  if (isTinyFish) fightRecovery = Math.min(fightRecovery, 10);
  fightRecovery = clampNumber(fightRecovery, 0, 100);

  var fightControl = [0, 5, 12, 26, 48, 72, 92][fightMassClass];
  if (isBulldog) fightControl += 18;
  if (isSharkLike) fightControl += 10;
  if (habitatStructure >= 65) fightControl += 6;
  if (textHasAny(commandText, ['hard to turn', 'digs deep', 'hard to control', 'bulldog', 'won’t plane up', "won't plane up"])) fightControl += 18;
  if (isTinyFish) fightControl = Math.min(fightControl, 10);
  if (isPanfish) fightControl = Math.min(fightControl, 18);
  fightControl = clampNumber(fightControl, 0, 100);

    var headline1 = getRowValue(row, ['headline_1']);
  var headline2 = getRowValue(row, ['headline_2']);
  var headline3 = getRowValue(row, ['headline_3']);

  var summary1 = getRowValue(row, ['summary_1']);
  var summary2 = getRowValue(row, ['summary_2']);
  var summary3 = getRowValue(row, ['summary_3']);

  var implication1a = getRowValue(row, ['implication_1a']);
  var implication1b = getRowValue(row, ['implication_1b']);
  var implication1c = getRowValue(row, ['implication_1c']);

  var implication2a = getRowValue(row, ['implication_2a']);
  var implication2b = getRowValue(row, ['implication_2b']);
  var implication2c = getRowValue(row, ['implication_2c']);

  return {
    title: title,
    scientific_name: scientificName,
    url: guideUrl,
    handle: guideUrl || title,
    image: imageUrl,
    comparison_copy: {
      headlines: [headline1, headline2, headline3].filter(Boolean),
      summaries: [summary1, summary2, summary3].filter(Boolean),
      primary_implications: [implication1a, implication1b, implication1c].filter(Boolean),
      compare_implications: [implication2a, implication2b, implication2c].filter(Boolean)
    },
    behavior: {
      theme: 'behavior',
      axes: [
        { key: 'aggression', label: 'Aggression', value: behaviorAggression },
        { key: 'wariness', label: 'Wariness', value: behaviorWariness },
        { key: 'fight_intensity', label: 'Fight', value: behaviorFight },
        { key: 'structure_dependence', label: 'Structure', value: behaviorStructure },
        { key: 'roaming_behavior', label: 'Roaming', value: behaviorRoaming },
        { key: 'surface_feeding', label: 'Surface', value: behaviorSurface },
        { key: 'schooling_behavior', label: 'Schooling', value: behaviorSchooling },
        { key: 'feeding_windows', label: 'Feed Window', value: behaviorFeedingWindows }
      ]
    },
    strike: {
      theme: 'strike',
      axes: [
        { key: 'trigger_sensitivity', label: 'Trigger', value: strikeTrigger },
        { key: 'selectivity', label: 'Selectivity', value: strikeSelectivity },
        { key: 'strike_speed', label: 'Speed', value: strikeSpeed },
        { key: 'strike_commitment', label: 'Commitment', value: strikeCommitment },
        { key: 'presentation_precision', label: 'Precision', value: strikePrecision },
        { key: 'stealth_requirement', label: 'Stealth', value: strikeStealth },
        { key: 'reaction_bias', label: 'Reaction', value: strikeReaction },
        { key: 'opportunistic_feeding', label: 'Opportunism', value: strikeOpportunism }
      ]
    },
    habitat: {
      theme: 'habitat',
      axes: [
        { key: 'structure_affinity', label: 'Structure', value: habitatStructure },
        { key: 'depth_preference', label: 'Depth', value: habitatDepth },
        { key: 'cover_dependency', label: 'Cover', value: habitatCover },
        { key: 'roaming_behavior', label: 'Roaming', value: habitatRoaming },
        { key: 'current_dependency', label: 'Current', value: habitatCurrent },
        { key: 'ambush_positioning', label: 'Ambush', value: habitatAmbush },
        { key: 'zone_specificity', label: 'Zone Spec.', value: habitatZoneSpec },
        { key: 'vertical_mobility', label: 'Vertical', value: habitatVertical }
      ]
    },
    fight: {
      theme: 'fight',
      axes: [
        { key: 'initial_run_power', label: 'Run Power', value: fightRunPower },
        { key: 'endurance', label: 'Endurance', value: fightEndurance },
        { key: 'directional_chaos', label: 'Chaos', value: fightChaos },
        { key: 'aerial_behavior', label: 'Aerial', value: fightAerial },
        { key: 'line_stress', label: 'Line Stress', value: fightLineStress },
        { key: 'landing_difficulty', label: 'Landing', value: fightLanding },
        { key: 'recovery_bursts', label: 'Recovery', value: fightRecovery },
        { key: 'control_resistance', label: 'Control', value: fightControl }
      ]
    }
  };
}

function clearRadarOverlay(container) {
  if (!container) return;
  var svg = container.querySelector('.species-radar__svg');
  if (!svg) return;

  Array.prototype.slice.call(svg.querySelectorAll('[data-compare-overlay="true"]')).forEach(function (node) {
    node.remove();
  });
}

function renderRadarOverlay(container, compareData) {
  if (!container || !compareData || !compareData.axes || !compareData.axes.length) return;

  var svg = container.querySelector('.species-radar__svg');
  if (!svg) return;

  clearRadarOverlay(container);

  var theme = compareData.theme || 'behavior';
  var cx = 140;
  var cy = 140;
  var maxRadius = 117;
  var startAngle = -Math.PI / 2;
  var compareHandle = compareData.handle || '';

var adjustedCompareAxes = compareData.axes.map(function (axis) {
  var baseValue = parseFloat(axis.value) || 0;
  var offset = getStableAxisOffset(compareHandle, axis.key);

  return {
    key: axis.key,
    label: axis.label,
    value: clamp(baseValue + offset, 0, 100)
  };
});

var points = buildValuePoints(adjustedCompareAxes, cx, cy, maxRadius, 100, startAngle);

  var centerPoints = points.map(function () {
    return {
      x: cx,
      y: cy
    };
  });

  function pointsToString(pointList) {
    return pointList.map(function (point) {
      return point.x.toFixed(2) + ',' + point.y.toFixed(2);
    }).join(' ');
  }

  var polygon = createSvgNode('polygon', {
    points: pointsToString(centerPoints),
    'class': 'species-radar__shape species-radar__shape--compare-' + theme,
    'data-compare-overlay': 'true'
  });

  polygon.style.opacity = '0';
  svg.appendChild(polygon);

  var dots = points.map(function () {
    var dot = createSvgNode('circle', {
      cx: cx,
      cy: cy,
      r: 2.5,
      'class': 'species-radar__dot species-radar__dot--compare-' + theme,
      'data-compare-overlay': 'true'
    });

    dot.style.opacity = '0';
    svg.appendChild(dot);
    return dot;
  });

  var duration = 900;
  var startTime = null;

  function animateOverlay(timestamp) {
    if (!startTime) startTime = timestamp;

    var progress = Math.min((timestamp - startTime) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);

    var currentPoints = points.map(function (point) {
      return {
        x: cx + ((point.x - cx) * eased),
        y: cy + ((point.y - cy) * eased)
      };
    });

    polygon.setAttribute('points', pointsToString(currentPoints));
    polygon.style.opacity = String(0.95 * eased);

    dots.forEach(function (dot, index) {
      var point = points[index];
      var delay = index * 0.035;
      var dotProgress = Math.max(0, Math.min(1, (progress - delay) / (1 - delay)));
      var dotEased = 1 - Math.pow(1 - dotProgress, 3);

      var currentX = cx + ((point.x - cx) * dotEased);
      var currentY = cy + ((point.y - cy) * dotEased);

      dot.setAttribute('cx', currentX.toFixed(2));
      dot.setAttribute('cy', currentY.toFixed(2));
      dot.style.opacity = String(0.9 * dotEased);
    });

    if (progress < 1) {
      window.requestAnimationFrame(animateOverlay);
    } else {
      polygon.setAttribute('points', pointsToString(points));
      polygon.style.opacity = '';

      dots.forEach(function (dot, index) {
        dot.setAttribute('cx', points[index].x.toFixed(2));
        dot.setAttribute('cy', points[index].y.toFixed(2));
        dot.style.opacity = '';
      });
    }
  }

  window.requestAnimationFrame(animateOverlay);
}



function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function getStableAxisOffset(handle, axisKey) {
  var source = String(handle || '') + '|' + String(axisKey || '');
  var offsets = [-3, -2.5, -2, -1.5, -1, -0.5, 0, 0.5, 1, 1.5, 2, 2.5, 3];
  var hash = 0;

  for (var i = 0; i < source.length; i++) {
    hash += source.charCodeAt(i) * (i + 1);
  }

  return offsets[Math.abs(hash) % offsets.length];
}

function createSvgNode(tagName, attrs) {
  var node = document.createElementNS('http://www.w3.org/2000/svg', tagName);
  Object.keys(attrs || {}).forEach(function (key) {
    node.setAttribute(key, attrs[key]);
  });
  return node;
}

function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + (Math.cos(angle) * radius),
    y: cy + (Math.sin(angle) * radius)
  };
}

function buildPolygonPoints(axisCount, cx, cy, radius, startAngle) {
  var points = [];
  var step = (Math.PI * 2) / axisCount;

  for (var i = 0; i < axisCount; i++) {
    var angle = startAngle + (step * i);
    var point = polarToCartesian(cx, cy, radius, angle);
    points.push(point.x.toFixed(2) + ',' + point.y.toFixed(2));
  }

  return points.join(' ');
}

function buildValuePoints(axes, cx, cy, maxRadius, maxValue, startAngle) {
  var points = [];
  var step = (Math.PI * 2) / axes.length;

  axes.forEach(function (axis, index) {
    var angle = startAngle + (step * index);
   var scale = 1.6;
var radius = (clamp(axis.value, 0, maxValue) / maxValue) * maxRadius * scale;
radius = Math.min(radius, maxRadius); // prevent overflow
    var point = polarToCartesian(cx, cy, radius, angle);

    points.push({
      x: point.x,
      y: point.y,
      value: axis.value,
      label: axis.label,
      key: axis.key,
      angle: angle
    });
  });

  return points;
}

function formatRadarValue(value) {
  var rounded = Math.round(value * 10) / 10;
  if (Math.abs(rounded % 1) < 0.001) {
    return String(Math.round(rounded));
  }
  return rounded.toFixed(1);
}

function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

function getRadarAxisSeed(handle, axisKey) {
  var source = String(handle || '') + '::' + String(axisKey || '');
  var hash = 0;

  for (var i = 0; i < source.length; i++) {
    hash = ((hash << 5) - hash) + source.charCodeAt(i);
    hash |= 0;
  }

  return Math.abs(hash);
}

function getRadarAxisWobble(handle, axisKey, baseValue) {
  var seed = getRadarAxisSeed(handle, axisKey);
  var amplitudes = [10, 12, 14, 16, 18, 20, 22];
  var signs = [-1, 1];
  var amplitude = amplitudes[seed % amplitudes.length];
  var sign = signs[(Math.floor(seed / 7)) % signs.length];

  if (baseValue >= 75) amplitude += 2;
  if (baseValue <= 20) amplitude -= 1;

  amplitude = Math.max(8, amplitude);

  return amplitude * sign;
}

function buildAnimatedRadarState(axes, handle, maxValue) {
  return axes.map(function (axis, index) {
    var baseValue = parseFloat(axis.value) || 0;
    var stableOffset = getStableAxisOffset(handle, axis.key);
    var finalValue = clamp(baseValue + stableOffset, 0, maxValue);
    var wobble = getRadarAxisWobble(handle, axis.key, finalValue);

    return {
      key: axis.key,
      label: axis.label,
      finalValue: finalValue,
      displayValue: finalValue,
      wobble: wobble,
      index: index
    };
  });
}

function updateRadarVisual(container, axisStates, maxValue, theme) {
  var svg = container.querySelector('.species-radar__svg');
  var legendWrap = container.querySelector('[data-radar-legend]');
  var polygon = svg ? svg.querySelector('[data-radar-polygon]') : null;
  var dots = svg ? svg.querySelectorAll('[data-radar-dot]') : [];
  if (!svg || !legendWrap || !polygon) return;

  var cx = 140;
  var cy = 140;
  var maxRadius = 117;
  var startAngle = -Math.PI / 2;

  var points = buildValuePoints(axisStates.map(function (axis) {
    return {
      key: axis.key,
      label: axis.label,
      value: axis.displayValue
    };
  }), cx, cy, maxRadius, maxValue, startAngle);

  polygon.setAttribute('points', points.map(function (point) {
    return point.x.toFixed(2) + ',' + point.y.toFixed(2);
  }).join(' '));

  points.forEach(function (point, index) {
    if (!dots[index]) return;
    dots[index].setAttribute('cx', point.x.toFixed(2));
    dots[index].setAttribute('cy', point.y.toFixed(2));
  });

  var legendValues = legendWrap.querySelectorAll('[data-radar-legend-value]');
  axisStates.forEach(function (axis, index) {
    if (!legendValues[index]) return;
    legendValues[index].textContent = formatRadarValue(axis.displayValue);
  });

  if (theme === 'strike') {
    polygon.style.opacity = '1';
  } else {
    polygon.style.opacity = '1';
  }
}

function animateRadarReveal(container, axisStates, maxValue, theme) {
  if (!container || container.getAttribute('data-radar-animated') === 'true') return;

  var duration = 5000;
  var settleStart = 0.58;
  var wobbleCycles = 2;
  var startTime = null;

  container.setAttribute('data-radar-animated', 'true');

  axisStates.forEach(function (axis) {
    axis.displayValue = clamp(axis.finalValue + (axis.wobble * 2.1), 0, maxValue);
    axis.settleStarted = false;
    axis.settleFromValue = axis.displayValue;
  });

  updateRadarVisual(container, axisStates, maxValue, theme);

  function frame(timestamp) {
    if (!startTime) startTime = timestamp;

    var rawProgress = Math.min((timestamp - startTime) / duration, 1);

    axisStates.forEach(function (axis) {
      var axisDelay = axis.index * 0.028;
      var axisProgress = clamp((rawProgress - axisDelay) / (1 - axisDelay), 0, 1);

      if (axisProgress < settleStart) {
        var localProgress = axisProgress / settleStart;
        var wave = Math.sin(localProgress * Math.PI * wobbleCycles);
        var decay = 1 - easeOutCubic(localProgress);
        var driftToFinal = easeInOutQuad(localProgress) * 0.42;

        axis.displayValue = clamp(
          axis.finalValue +
          (axis.wobble * 1.15 * wave * decay) +
          (axis.wobble * 0.68 * (1 - driftToFinal)),
          0,
          maxValue
        );
      } else {
        if (!axis.settleStarted) {
          axis.settleStarted = true;
          axis.settleFromValue = axis.displayValue;
        }

        var settleProgress = (axisProgress - settleStart) / (1 - settleStart);
        var easedSettle = easeInOutQuad(settleProgress);

        axis.displayValue = clamp(
          axis.settleFromValue + ((axis.finalValue - axis.settleFromValue) * easedSettle),
          0,
          maxValue
        );
      }
    });

    updateRadarVisual(container, axisStates, maxValue, theme);

    if (rawProgress < 1) {
      window.requestAnimationFrame(frame);
    } else {
      axisStates.forEach(function (axis) {
        axis.displayValue = axis.finalValue;
      });
      updateRadarVisual(container, axisStates, maxValue, theme);
    }
  }

  window.requestAnimationFrame(frame);
}

function initRadarRevealObserver() {
  var radars = document.querySelectorAll('[data-radar-ready="true"]');
  if (!radars.length) return;

  function revealRadar(radar) {
    if (!radar || radar.getAttribute('data-radar-reveal-ready') === 'true') return;

    var rawConfig = radar.getAttribute('data-radar-config');
    if (!rawConfig) return;

    try {
      var config = JSON.parse(rawConfig);
      var maxValue = config.max || 100;
      var theme = config.theme || 'behavior';
      var axisStates = buildAnimatedRadarState(config.axes, config.handle || '', maxValue);

      radar.setAttribute('data-radar-reveal-ready', 'true');
      animateRadarReveal(radar, axisStates, maxValue, theme);
    } catch (error) {
      console.error('Radar reveal init failed', error);
    }
  }

  if (!('IntersectionObserver' in window)) {
    radars.forEach(revealRadar);
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealRadar(entry.target);
      obs.unobserve(entry.target);
    });
  }, {
    threshold: 0.35
  });

  radars.forEach(function (radar) {
    observer.observe(radar);
  });
}

function getRadarTooltipText(theme, label) {
  var behaviorTips = {
    'Aggression': 'How likely the fish is to attack hard vs hesitate or inspect',
    'Wariness': 'How easily the fish gets spooked by movement, noise, or pressure',
    'Fight': 'How strong and sustained the fish is once hooked',
    'Structure': 'How tightly the fish relates to cover like rocks, wood, or edges',
    'Roaming': 'How much the fish moves vs holding a specific position',
    'Surface': 'How often the fish feeds near or breaks the surface',
    'Schooling': 'Whether the fish groups up or tends to act alone',
    'Feed Window': 'How narrow or wide the timeframes are when this fish actively feeds'
  };

  var strikeTips = {
    'Trigger': 'How easily this fish commits to starting a strike',
    'Selectivity': 'How picky this fish is about bait, size, and presentation',
    'Speed': 'The retrieve speed that best triggers a bite',
    'Commitment': 'How likely the fish is to fully commit vs short strike',
    'Precision': 'How accurately the fish targets and hits your bait',
    'Stealth': 'How much subtlety is needed to avoid spooking it',
    'Reaction': 'How strongly the fish responds to sudden movement',
    'Opportunism': 'How often it takes advantage of easy chances'
  };

  var habitatTips = {
    'Structure': 'How tightly this fish positions around reefs, docks, rocks, timber, ledges, or hard edges',
    'Depth': 'Whether this fish tends to relate more to deeper water or shallower zones',
    'Cover': 'How dependent this fish is on grass, mangroves, wrecks, weeds, timber, or other cover',
    'Roaming': 'Whether this fish tends to move constantly or hold in a tighter zone',
    'Current': 'How strongly moving water, seams, tide, or flow influence where this fish sets up',
    'Ambush': 'How much this fish uses hiding spots or positioning to strike from cover or edges',
    'Zone Spec.': 'How tightly this fish locks into specific windows, lanes, depth bands, or structural zones',
    'Vertical': 'How much this fish moves up and down through the water column instead of staying on one level'
  };

  var fightTips = {
    'Run Power': 'How hard this fish takes off right after the hookset',
    'Endurance': 'How long this fish can sustain a strong fight',
    'Chaos': 'How erratic this fish is once hooked, including sudden directional changes',
    'Aerial': 'How likely this fish is to jump, shake, or go airborne during the fight',
    'Line Stress': 'How much pressure this fish puts on line, knots, drag, and tackle',
    'Landing': 'How difficult this fish is to bring cleanly to hand, net, or boat',
    'Recovery': 'How likely this fish is to fire off again after seeming tired',
    'Control': 'How hard this fish is to turn, guide, plane up, or keep under control'
  };

  if (theme === 'strike') {
    return strikeTips[label] || '';
  }

  if (theme === 'habitat') {
    return habitatTips[label] || '';
  }

  if (theme === 'fight') {
    return fightTips[label] || '';
  }

  return behaviorTips[label] || '';
}

function renderRadar(container, config) {
  if (!container || !config || !config.axes || !config.axes.length) return;

  var svg = container.querySelector('.species-radar__svg');
  var labelsWrap = container.querySelector('[data-radar-labels]');
  var legendWrap = container.querySelector('[data-radar-legend]');
  if (!svg || !labelsWrap || !legendWrap) return;

  var axisCount = config.axes.length;
  var maxValue = config.max || 100;
  var size = 280;
  var cx = 140;
  var cy = 140;
  var maxRadius = 117;
  var labelRadius = 125;
  var startAngle = -Math.PI / 2;
  var ringRatios = [0.25, 0.5, 0.75, 1];
  var step = (Math.PI * 2) / axisCount;
  var speciesHandle = config.handle || '';
  var radarTheme = config.theme || 'behavior';

  var adjustedAxes = config.axes.map(function (axis) {
    var baseValue = parseFloat(axis.value) || 0;
    var offset = getStableAxisOffset(speciesHandle, axis.key);
    return {
      key: axis.key,
      label: axis.label,
      value: clamp(baseValue + offset, 0, maxValue)
    };
  });

  svg.innerHTML = '';
  labelsWrap.innerHTML = '';
  legendWrap.innerHTML = '';

  ringRatios.forEach(function (ratio, index) {
    var ringRadius = maxRadius * ratio;
    var ring = createSvgNode('polygon', {
      points: buildPolygonPoints(axisCount, cx, cy, ringRadius, startAngle),
      'class': index === ringRatios.length - 1 ? 'species-radar__frame' : 'species-radar__ring'
    });
    svg.appendChild(ring);
  });

  adjustedAxes.forEach(function (axis, index) {
    var angle = startAngle + (step * index);
    var outerPoint = polarToCartesian(cx, cy, maxRadius, angle);
    var axisLine = createSvgNode('line', {
      x1: cx,
      y1: cy,
      x2: outerPoint.x.toFixed(2),
      y2: outerPoint.y.toFixed(2),
      'class': 'species-radar__axis'
    });
    svg.appendChild(axisLine);
  });

  var valuePoints = buildValuePoints(adjustedAxes, cx, cy, maxRadius, maxValue, startAngle);

  var shape = createSvgNode('polygon', {
    points: valuePoints.map(function (point) {
      return point.x.toFixed(2) + ',' + point.y.toFixed(2);
    }).join(' '),
    'class': 'species-radar__shape species-radar__shape--' + radarTheme,
    'data-radar-polygon': 'true'
  });
  svg.appendChild(shape);

  valuePoints.forEach(function (point) {
    var dot = createSvgNode('circle', {
      cx: point.x.toFixed(2),
      cy: point.y.toFixed(2),
      r: 3.5,
      'class': 'species-radar__dot species-radar__dot--' + radarTheme,
      'data-radar-dot': 'true'
    });
    svg.appendChild(dot);
  });

  adjustedAxes.forEach(function (axis, index) {
    var angle = startAngle + (step * index);
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);

    var effectiveLabelRadius = labelRadius;

    if (axis.label === 'Commitment') {
      effectiveLabelRadius = labelRadius - 25;
    } else if (cos < -0.82) {
      effectiveLabelRadius = labelRadius - 36;
    } else if (cos > 0.82) {
      effectiveLabelRadius = labelRadius - 20;
    } else if (Math.abs(cos) > 0.55) {
      effectiveLabelRadius = labelRadius - 8;
    }

    var labelPoint = polarToCartesian(cx, cy, effectiveLabelRadius, angle);
    var label = document.createElement('div');
    var tooltipText = getRadarTooltipText(radarTheme, axis.label);

    var translateX = '-50%';
    var translateY = '-50%';
    var textAlign = 'center';
    var offsetY = 0;

    if (cos > 0.32) {
      translateX = '0';
      textAlign = 'left';
    } else if (cos < -0.32) {
      translateX = '-100%';
      textAlign = 'right';
    }

    if (sin > 0.52) {
      translateY = '0';
    } else if (sin < -0.52) {
      translateY = '-100%';
    }

    if (cos > 0.92 || cos < -0.92) {
      offsetY = 8;
    }

    label.className = 'species-radar__label species-radar__label--dynamic';
    label.textContent = axis.label;
    label.style.left = ((labelPoint.x / size) * 100) + '%';
    label.style.top = 'calc(' + ((labelPoint.y / size) * 100) + '% + ' + offsetY + 'px)';
    label.style.transform = 'translate(' + translateX + ', ' + translateY + ')';
    label.style.textAlign = textAlign;

    if (tooltipText) {
      label.setAttribute('title', tooltipText);
      label.setAttribute('data-radar-tooltip', tooltipText);
      label.setAttribute('tabindex', '0');
      label.setAttribute('aria-label', axis.label + ': ' + tooltipText);
    }

    labelsWrap.appendChild(label);
  });

  adjustedAxes.forEach(function (axis) {
    var item = document.createElement('span');
    item.className = 'species-radar__legendItem';
    item.innerHTML = '<span class="species-radar__legendLabel">' + axis.label + '</span><span class="species-radar__legendValue" data-radar-legend-value="true">' + formatRadarValue(axis.value) + '</span>';
    legendWrap.appendChild(item);
  });

  container.setAttribute('data-radar-rendered', 'true');
}

function initRadarTooltips() {
  var tooltip = document.querySelector('[data-species-tooltip]');
  if (!tooltip) return;

  var labels = document.querySelectorAll('.species-radar__label--dynamic');

  function showTooltip(el) {
    var text = el.getAttribute('data-radar-tooltip');
    if (!text) return;

    tooltip.textContent = text;
    tooltip.classList.add('is-visible');

    positionTooltip(el);
  }

  function hideTooltip() {
    tooltip.classList.remove('is-visible');
  }

  function positionTooltip(el) {
    var rect = el.getBoundingClientRect();

    var x = rect.left + rect.width / 2;
    var y = rect.top;

    tooltip.style.left = x + 'px';
    tooltip.style.top = y + 'px';
  }

  labels.forEach(function (label) {
    label.addEventListener('mouseenter', function () {
      showTooltip(label);
    });

    label.addEventListener('mouseleave', function () {
      hideTooltip();
    });

    label.addEventListener('focus', function () {
      showTooltip(label);
    });

    label.addEventListener('blur', function () {
      hideTooltip();
    });

    label.addEventListener('mousemove', function () {
      positionTooltip(label);
    });
  });
}


function initBehaviorRadars() {
  var radars = document.querySelectorAll('[data-radar]');

  radars.forEach(function (container) {
    if (container.getAttribute('data-radar-ready') === 'true') return;

    var rawConfig = container.getAttribute('data-radar-config');
    if (!rawConfig) return;

    try {
      var config = JSON.parse(rawConfig);
      renderRadar(container, config);
      container.setAttribute('data-radar-ready', 'true');
    } catch (error) {
      console.error('Behavior radar config parse failed', error);
    }
  });

  initRadarRevealObserver();
}

(function () {

  document.documentElement.classList.add('species-js');

  var pageConfig = window.FishyAFSpeciesPage || {};
  var MOBILE_MEDALLION_BREAKPOINT = window.matchMedia('(max-width: 560px)');
  var SPECIES_DISPLAY_TITLE = pageConfig.displayTitle || '';
  var CURRENT_SPECIES_URL = pageConfig.currentSpeciesUrl || '';
  var SPECIES_RANDOM_URLS = Array.isArray(pageConfig.randomUrls) ? pageConfig.randomUrls : [];

  function initMedallion() {
    var badge = document.querySelector('.species-medallion');
    if (!badge) return;

    badge.addEventListener('click', function () {
      if (!MOBILE_MEDALLION_BREAKPOINT.matches) return;
      badge.classList.toggle('is-expanded');
    });

    if (MOBILE_MEDALLION_BREAKPOINT.addEventListener) {
      MOBILE_MEDALLION_BREAKPOINT.addEventListener('change', function (e) {
        if (!e.matches) {
          badge.classList.remove('is-expanded');
        }
      });
    } else if (MOBILE_MEDALLION_BREAKPOINT.addListener) {
      MOBILE_MEDALLION_BREAKPOINT.addListener(function (e) {
        if (!e.matches) {
          badge.classList.remove('is-expanded');
        }
      });
    }
  }

  function shuffleArray(items) {
    var array = items.slice();
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  function renumberFishyafFacts(items) {
    items.forEach(function (item, index) {
      var num = item.querySelector('.species-fishyafFacts__num');
      if (!num) return;

      if (item.classList.contains('species-fishyafFacts__item--signature')) {
        num.innerHTML = '<span class="species-fishyafFacts__topIcon">🔥</span>';
        return;
      }

      var displayNumber = String(index + 1).padStart(2, '0');
      num.textContent = displayNumber;
    });
  }

  function setFishyafFactsButtonState(container, expanded) {
    var toggle = container.querySelector('[data-fishyaf-facts-toggle]');
    var text = container.querySelector('.species-fishyafFacts__toggleText');
    if (!toggle || !text) return;

    container.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    text.textContent = expanded ? 'Show Less' : 'Show 5 More Facts';
  }

  function initFishyafFacts() {
    var containers = document.querySelectorAll('[data-fishyaf-facts]');

    containers.forEach(function (container) {
      if (!container || container.getAttribute('data-fishyaf-facts-ready') === 'true') return;

      var list = container.querySelector('[data-fishyaf-facts-list]');
      var toggle = container.querySelector('[data-fishyaf-facts-toggle]');
      if (!list || !toggle) return;

      var signatureItem = list.querySelector('[data-fact-role="signature"]');
      var funItems = Array.prototype.slice.call(list.querySelectorAll('[data-fact-role="fun"]'));

      if (!signatureItem || !funItems.length) {
        toggle.hidden = true;
        container.setAttribute('data-fishyaf-facts-ready', 'true');
        return;
      }

      var shuffledFunItems = shuffleArray(funItems);
      var orderedItems = [signatureItem].concat(shuffledFunItems);

      orderedItems.forEach(function (item, index) {
        list.appendChild(item);
        item.classList.remove('is-extra');
        item.removeAttribute('aria-hidden');

        if (index > 4) {
          item.classList.add('is-extra');
          item.setAttribute('aria-hidden', 'true');
        }
      });

      renumberFishyafFacts(orderedItems);

      if (orderedItems.length > 5) {
        toggle.hidden = false;
        setFishyafFactsButtonState(container, false);

        toggle.addEventListener('click', function () {
          var expanded = container.classList.contains('is-expanded');
          setFishyafFactsButtonState(container, !expanded);

          var extraItems = container.querySelectorAll('.species-fishyafFacts__item.is-extra');
          extraItems.forEach(function (item) {
            item.setAttribute('aria-hidden', expanded ? 'true' : 'false');
          });
        });
      } else {
        toggle.hidden = true;
      }

      container.setAttribute('data-fishyaf-facts-ready', 'true');
    });
  }

  function initVoiceSelector() {
  var selectors = document.querySelectorAll('[data-voice-selector]');
  if (!selectors.length) return;

  selectors.forEach(function (selector) {
    var root = selector.closest('.species-sectionBody');
    if (!root) return;

    var tabs = Array.prototype.slice.call(
      selector.querySelectorAll('[data-voice-tab]')
    );

    var panels = Array.prototype.slice.call(
      root.querySelectorAll('[data-voice-panel]')
    );

    if (!tabs.length || !panels.length) return;

    function activateVoice(key) {
      var nextPanel = null;

      tabs.forEach(function (tab) {
        var isMatch = tab.getAttribute('data-voice-tab') === key;
        tab.classList.toggle('is-active', isMatch);
        tab.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-voice-panel') === key;
        if (isMatch) nextPanel = panel;

        if (!isMatch && !panel.hidden) {
          panel.style.opacity = '0';
          panel.style.transform = 'translateY(6px)';
        }
      });

      window.setTimeout(function () {
        panels.forEach(function (panel) {
          var isMatch = panel.getAttribute('data-voice-panel') === key;
          panel.classList.toggle('is-active', isMatch);
          panel.hidden = !isMatch;

          if (isMatch) {
            panel.style.opacity = '0';
            panel.style.transform = 'translateY(6px)';
          }
        });

        if (nextPanel) {
          window.requestAnimationFrame(function () {
            nextPanel.style.opacity = '1';
            nextPanel.style.transform = 'translateY(0)';
          });
        }
      }, 90);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-voice-tab');
        if (!key) return;
        activateVoice(key);
      });
    });

    activateVoice('fishyaf');
  });
}

  function getLineHeight(el) {
    var computed = window.getComputedStyle(el);
    var lineHeight = parseFloat(computed.lineHeight);
    if (!isNaN(lineHeight)) return lineHeight;
    var fontSize = parseFloat(computed.fontSize) || 16;
    return fontSize * 1.6;
  }

  function contentNeedsClamp(contentEl, lines) {
    if (!contentEl) return false;
    var lineHeight = getLineHeight(contentEl);
    var threshold = Math.ceil((lineHeight * lines) + 18);
    return contentEl.scrollHeight > threshold;
  }

  function scrollOverviewToTop(block) {
    if (!block) return;
    block.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function setToggleState(block, expanded) {
    var content = block.querySelector('[data-collapsible-content]');
    var toggle = block.querySelector('[data-collapsible-toggle]');
    if (!content || !toggle) return;

    block.classList.toggle('is-expanded', expanded);
    block.classList.toggle('is-collapsed', !expanded);
    content.classList.toggle('is-expanded', expanded);
    content.classList.toggle('is-collapsed', !expanded);

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Show Less' : 'Read Full Guide';
  }

  function wrapFirstSpeciesNameInOverview() {
    if (!SPECIES_DISPLAY_TITLE) return;

    var overviewBlocks = document.querySelectorAll('.species-collapsible--overview [data-collapsible-content]');
    overviewBlocks.forEach(function (content) {
      if (!content || content.getAttribute('data-species-name-styled') === 'true') return;

      var firstElement = content.firstElementChild;
      if (!firstElement) return;

      var walker = document.createTreeWalker(firstElement, NodeFilter.SHOW_TEXT, null);
      var node;
      var done = false;

      while ((node = walker.nextNode()) && !done) {
        var text = node.nodeValue || '';
        var index = text.indexOf(SPECIES_DISPLAY_TITLE);

        if (index !== -1) {
          var before = text.slice(0, index);
          var match = text.slice(index, index + SPECIES_DISPLAY_TITLE.length);
          var after = text.slice(index + SPECIES_DISPLAY_TITLE.length);

          var frag = document.createDocumentFragment();
          if (before) frag.appendChild(document.createTextNode(before));

          var span = document.createElement('span');
          span.className = 'species-inline-name';
          span.textContent = match;
          frag.appendChild(span);

          if (after) frag.appendChild(document.createTextNode(after));

          node.parentNode.replaceChild(frag, node);
          done = true;
        }
      }

      content.setAttribute('data-species-name-styled', 'true');
    });
  }

  function enhanceCollapsible(block) {
  if (!block) return;

  var content = block.querySelector('[data-collapsible-content]');
  var toggle = block.querySelector('[data-collapsible-toggle]');
  var lines = parseInt(block.getAttribute('data-clamp-lines'), 10) || 3;

  if (!content || !toggle) return;

  content.style.setProperty('--species-clamp-lines', String(lines));

  /*
    Bind interactions immediately, even if the lazy-loaded
    voice content has not been inserted yet.
  */
  if (toggle.getAttribute('data-collapsible-bound') !== 'true') {
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();

      var expanded =
        toggle.getAttribute('aria-expanded') === 'true';

      setToggleState(block, !expanded);

      if (
        expanded &&
        block.classList.contains('species-collapsible--overview')
      ) {
        scrollOverviewToTop(block);
      }
    });

    toggle.setAttribute('data-collapsible-bound', 'true');
  }

  if (
    block.classList.contains('species-collapsible--overview') &&
    content.getAttribute('data-collapsible-content-bound') !== 'true'
  ) {
    content.addEventListener('click', function (e) {
      if (!block.classList.contains('is-expanded')) return;

      var interactive = e.target.closest(
        'a, button, input, textarea, select, summary'
      );

      if (interactive) return;

      setToggleState(block, false);
      scrollOverviewToTop(block);
    });

    content.setAttribute(
      'data-collapsible-content-bound',
      'true'
    );
  }

  /*
    At initial page load the deferred voice may still be empty.
    That's okay — its click handler is already bound above.
  */
  if (!contentNeedsClamp(content, lines)) {
    toggle.hidden = true;
    toggle.setAttribute('aria-hidden', 'true');

    block.classList.remove('is-collapsed', 'is-expanded');
    content.classList.remove('is-collapsed', 'is-expanded');

    return;
  }

  toggle.hidden = false;
  toggle.removeAttribute('aria-hidden');

  if (!block.classList.contains('is-expanded')) {
    setToggleState(block, false);
  }
}

  function rebuildFaqParagraphWithStrongs(paragraph) {
    if (!paragraph || !paragraph.querySelector('strong')) return;

    var childNodes = Array.prototype.slice.call(paragraph.childNodes);
    var sections = [];
    var current = null;

    childNodes.forEach(function (node) {
      var isStrong = node.nodeType === 1 && node.tagName === 'STRONG';

      if (isStrong) {
        if (current) sections.push(current);
        current = {
          heading: node.cloneNode(true),
          bodyNodes: []
        };
      } else {
        if (!current) {
          current = {
            heading: null,
            bodyNodes: [node.cloneNode(true)]
          };
        } else {
          current.bodyNodes.push(node.cloneNode(true));
        }
      }
    });

    if (current) sections.push(current);

    var hasStructuredContent = sections.some(function (section) {
      return !!section.heading;
    });

    if (!hasStructuredContent) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'faq-formatted-answer';

    sections.forEach(function (section) {
      var subsection = document.createElement('div');
      subsection.className = 'faq-subsection';

      if (section.heading) {
        subsection.appendChild(section.heading);
      }

      var p = document.createElement('p');
      section.bodyNodes.forEach(function (node) {
        p.appendChild(node);
      });

      var hasVisibleText = (p.textContent || '').replace(/\s+/g, ' ').trim().length > 0;
      var hasElements = p.children.length > 0;

      if (hasVisibleText || hasElements) {
        subsection.appendChild(p);
      }

      if (subsection.children.length > 0) {
        wrapper.appendChild(subsection);
      }
    });

    if (wrapper.children.length) {
      paragraph.parentNode.replaceChild(wrapper, paragraph);
    }
  }

  function formatFaqAnswers() {
    var faqAnswers = document.querySelectorAll('.species-faqA .species-content');

    faqAnswers.forEach(function (content) {
      if (!content || content.getAttribute('data-faq-formatted') === 'true') return;

      var paragraphs = Array.prototype.slice.call(content.querySelectorAll('p'));
      paragraphs.forEach(function (paragraph) {
        if (paragraph.querySelector('strong')) {
          rebuildFaqParagraphWithStrongs(paragraph);
        }
      });

      content.setAttribute('data-faq-formatted', 'true');
    });
  }

  function initFaqAccordion() {
    var items = document.querySelectorAll('[data-faq-item]');

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-faq-toggle]');
      var answer = item.querySelector('[data-faq-answer]');
      if (!toggle || !answer) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          var otherToggle = otherItem.querySelector('[data-faq-toggle]');
          var otherAnswer = otherItem.querySelector('[data-faq-answer]');
          if (!otherToggle || !otherAnswer) return;

          otherItem.classList.remove('is-open');
          otherToggle.setAttribute('aria-expanded', 'false');
          otherAnswer.hidden = true;
        });

        if (!isOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  function initCollapsibles() {
    var collapsibles = document.querySelectorAll('[data-collapsible]');
    collapsibles.forEach(function (block) {
      enhanceCollapsible(block);
    });
  }

  function initRandomSpeciesButtons() {
    var buttons = document.querySelectorAll('[data-random-species]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        if (!SPECIES_RANDOM_URLS || !SPECIES_RANDOM_URLS.length) return;

        var pool = SPECIES_RANDOM_URLS.filter(function (url) {
          return url && url !== CURRENT_SPECIES_URL;
        });

        if (!pool.length) {
          pool = SPECIES_RANDOM_URLS.slice();
        }

        if (!pool.length) return;

        var nextUrl = pool[Math.floor(Math.random() * pool.length)];
        window.location.href = nextUrl;
      });
    });
  }

  function initFishingWindowReveal() {
    var cards = document.querySelectorAll('.species-command-card--rightnow');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, {
      threshold: 0.35
    });

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }
function debounce(fn, wait) {
  var timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(fn, wait);
  };
}
  function initDifficultyMeterReveal() {
    var cards = document.querySelectorAll('.species-command-card--difficulty');
    if (!cards.length) return;

    var tierClasses = [
      'species-command-meter--common',
      'species-command-meter--common-catch',
      'species-command-meter--explorer',
      'species-command-meter--savage',
      'species-command-meter--elite',
      'species-command-meter--legendary',
      'species-command-meter--god-damned-unicorn'
    ];

    function positionMeterEndpoint(card) {
      return;
    }

    function getTierData(score) {
  if (score <= 20) {
    return {
      label: 'Common Catch',
      descriptor: 'Widely Accessible',
      className: 'species-command-meter--common-catch'
    };
  }

  if (score <= 40) {
    return {
      label: 'Explorer',
      descriptor: 'Beginner Friendly',
      className: 'species-command-meter--explorer'
    };
  }

  if (score <= 60) {
    return {
      label: 'Savage',
      descriptor: 'Demands Skill',
      className: 'species-command-meter--savage'
    };
  }

  if (score <= 80) {
    return {
      label: 'Elite',
      descriptor: 'Serious Challenge',
      className: 'species-command-meter--elite'
    };
  }

  if (score <= 95) {
    return {
      label: 'Legendary',
      descriptor: 'Rare Mastery',
      className: 'species-command-meter--legendary'
    };
  }

  return {
    label: 'God-Damned Unicorn',
    descriptor: 'Almost Mythical',
    className: 'species-command-meter--god-damned-unicorn'
  };
}

    function applyTierToMeter(card, liveScore, revealDescriptor) {
      var meter = card.querySelector('.species-command-meter');
      var labelEl = card.querySelector('.species-command-meter__label');
      var descriptorEl = card.querySelector('.species-command-meter__descriptor');
      if (!meter || !labelEl || !descriptorEl) return;

      var tier = getTierData(liveScore);

      tierClasses.forEach(function (className) {
        meter.classList.remove(className);
      });

      meter.classList.add(tier.className);

      if (labelEl.textContent !== tier.label) {
        labelEl.textContent = tier.label;
      }

      if (descriptorEl.textContent !== tier.descriptor) {
        descriptorEl.textContent = tier.descriptor;
      }

      labelEl.classList.add('is-live');

      if (revealDescriptor) {
        descriptorEl.classList.add('is-live');
      } else {
        descriptorEl.classList.remove('is-live');
      }
    }

    function animateMeterScore(card) {
      var meter = card.querySelector('.species-command-meter');
      var scoreEl = card.querySelector('[data-meter-count]');
      var labelEl = card.querySelector('.species-command-meter__label');
      var descriptorEl = card.querySelector('.species-command-meter__descriptor');
      if (!meter || !scoreEl || !labelEl || !descriptorEl) return;

      var target = parseInt(meter.getAttribute('data-meter-score'), 10) || 0;
      var overshoot = Math.min(target + Math.max(6, Math.round(target * 0.14)), 100);

      var phase1Start = null;
      var phase1Duration = 3200;
      var phase2Duration = 1800;

      scoreEl.textContent = '0';
      labelEl.textContent = '';
      descriptorEl.textContent = '';
      labelEl.classList.remove('is-live');
      descriptorEl.classList.remove('is-live');

      function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      }

      function stepPhase1(timestamp) {
        if (!phase1Start) phase1Start = timestamp;

        var progress = Math.min((timestamp - phase1Start) / phase1Duration, 1);
        var eased = easeOutCubic(progress);
        var current = Math.round(overshoot * eased);

        scoreEl.textContent = String(current);
        applyTierToMeter(card, current, false);

        if (progress < 1) {
          window.requestAnimationFrame(stepPhase1);
        } else {
          var phase2Start = null;

          function stepPhase2(timestamp2) {
            if (!phase2Start) phase2Start = timestamp2;

            var progress2 = Math.min((timestamp2 - phase2Start) / phase2Duration, 1);
            var eased2 = easeInOutQuad(progress2);
            var current2 = Math.round(overshoot + ((target - overshoot) * eased2));

            scoreEl.textContent = String(current2);
            applyTierToMeter(card, current2, false);

            if (progress2 < 1) {
              window.requestAnimationFrame(stepPhase2);
            } else {
              scoreEl.textContent = String(target);
              applyTierToMeter(card, target, false);
            }
          }

          window.requestAnimationFrame(stepPhase2);
        }
      }

      window.requestAnimationFrame(stepPhase1);
    }

    function revealCard(card) {
      if (card.classList.contains('is-visible')) return;

      var meter = card.querySelector('.species-command-meter');
      var fill = card.querySelector('.species-command-meter__fill');
      var target = meter ? (parseInt(meter.getAttribute('data-meter-score'), 10) || 0) : 0;
      var overshoot = Math.min(target + Math.max(6, Math.round(target * 0.14)), 100);

      if (meter) {
        meter.style.setProperty('--meter-value', overshoot + '%');
      }

      positionMeterEndpoint(card);
      card.classList.add('is-visible');
      animateMeterScore(card);

      if (meter && fill) {
        window.setTimeout(function () {
          function handleFinalFillEnd(event) {
            if (event.propertyName !== 'clip-path') return;

            fill.removeEventListener('transitionend', handleFinalFillEnd);
            applyTierToMeter(card, target, true);
          }

          fill.addEventListener('transitionend', handleFinalFillEnd);
          meter.style.setProperty('--meter-value', target + '%');
        }, 3300);
      }
    }

    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        revealCard(card);
      });
    } else {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealCard(entry.target);
          obs.unobserve(entry.target);
        });
      }, {
        threshold: 0.35
      });

      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    window.addEventListener('resize', debounce(function () {
      cards.forEach(function (card) {
        if (card.classList.contains('is-visible')) {
          positionMeterEndpoint(card);
        }
      });
    }, 120));
  }

 function initFeedingTriggersReveal() {
  var cards = document.querySelectorAll('.species-command-card--dependencies');
  if (!cards.length) return;

  function animateBar(bar, target, delay) {
    window.setTimeout(function () {
      var overshoot = Math.min(target + 8, 100);
      var undershoot = Math.max(target - 4, 0);

      bar.style.transition = 'width 1.2s cubic-bezier(.16,.84,.44,1)';
      bar.style.width = overshoot + '%';

      window.setTimeout(function () {
        bar.style.transition = 'width .45s ease';
        bar.style.width = undershoot + '%';

        window.setTimeout(function () {
          bar.style.transition = 'width .38s ease-out';
          bar.style.width = target + '%';
        }, 220);
      }, 760);
    }, delay);
  }

  function revealCard(card) {
    if (card.classList.contains('is-visible')) return;

    card.classList.add('is-visible');

    var bars = card.querySelectorAll('[data-trigger-bar]');
    var primary = card.querySelector('[data-trigger-primary]');

    bars.forEach(function (bar, index) {
      var target = parseInt(bar.getAttribute('data-target-width'), 10) || 0;
      animateBar(bar, target, index * 140);
    });

    if (primary) {
      window.setTimeout(function () {
        primary.classList.add('is-live');
      }, 1050);
    }
  }

  if (!('IntersectionObserver' in window)) {
    cards.forEach(function (card) {
      revealCard(card);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealCard(entry.target);
      obs.unobserve(entry.target);
    });
  }, {
    threshold: 0.35
  });

  cards.forEach(function (card) {
    observer.observe(card);
  });
}

function initSectionSwitchUnderline() {
  var switchers = document.querySelectorAll('.species-sectionSwitch');

  switchers.forEach(function (switcher) {
    var underline = switcher.querySelector('.species-sectionSwitch__underline');
    var tabs = Array.prototype.slice.call(
      switcher.querySelectorAll('.species-sectionSwitch__tab')
    );

    if (!underline || !tabs.length) return;

    function moveUnderlineTo(tab) {
      if (!tab || tab.disabled || tab.getAttribute('aria-disabled') === 'true') return;

      var switcherRect = switcher.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();

      var left = tabRect.left - switcherRect.left;
      var width = tabRect.width;

      underline.style.left = left + 'px';
      underline.style.width = width + 'px';
      underline.style.opacity = '1';
    }

    function getActiveTab() {
      return switcher.querySelector('.species-sectionSwitch__tab.is-active') || tabs[0];
    }

    var activeTab = getActiveTab();
    if (activeTab) {
      moveUnderlineTo(activeTab);
    }

    tabs.forEach(function (tab) {
      var isDisabled = tab.disabled || tab.getAttribute('aria-disabled') === 'true';
      if (isDisabled) return;

      tab.addEventListener('mouseenter', function () {
        moveUnderlineTo(tab);
      });

      tab.addEventListener('focus', function () {
        moveUnderlineTo(tab);
      });

      tab.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          moveUnderlineTo(tab);
        });
      });
    });

    switcher.addEventListener('mouseleave', function () {
      moveUnderlineTo(getActiveTab());
    });

    window.addEventListener('resize', function () {
      moveUnderlineTo(getActiveTab());
    });
  });
}

   

function initSpeciesComparisonSelector() {
  var compareRoot = document.querySelector('[data-species-compare]');
  if (!compareRoot) return;

  if (compareRoot.getAttribute('data-compare-ready') === 'true') return;
  compareRoot.setAttribute('data-compare-ready', 'true');

  var fullCompareUrl = compareRoot.getAttribute('data-species-compare-csv') || '';
var csvUrl = fullCompareUrl;

var mobileDirectoryUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRk0AposyKnaZQEq1VHtjM9suwIJQ5NmapW0rnzHwl9FSwT9kSFom4MS4nFHOvDH9SBkbtIDle-z1Xv/pub?gid=183640673&single=true&output=csv';
var isMobileCompare = window.innerWidth <= 560;

if (isMobileCompare) {
  csvUrl = mobileDirectoryUrl;
}
  var matchupCsvUrl = compareRoot.getAttribute('data-matchup-csv') || '';
  var currentHandle = compareRoot.getAttribute('data-current-handle') || '';
  var currentName = compareRoot.getAttribute('data-current-name') || '';
  var currentUrl = compareRoot.getAttribute('data-current-url') || '';

  var searchInput = compareRoot.querySelector('[data-compare-search-input]');
  var resultsWrap = compareRoot.querySelector('[data-compare-results]');
  var clearBtn = compareRoot.querySelector('[data-compare-clear]');
  var randomBtn = compareRoot.querySelector('[data-compare-random]');
  var quickButtons = Array.prototype.slice.call(compareRoot.querySelectorAll('[data-compare-quick]'));

 

  var selectionWrap = document.querySelector('[data-compare-selection]');
  var selectionName = document.querySelector('[data-compare-selection-name]');
  var selectionScientific = document.querySelector('[data-compare-selection-scientific]');
  var selectionActions = document.querySelector('[data-compare-selection-actions]');
  var selectionLink = document.querySelector('[data-compare-selection-link]');
  var selectionRemove = document.querySelector('[data-compare-selection-remove]');

  var statusEl = document.querySelector('[data-compare-status]');
  var liveRegion = compareRoot.querySelector('[data-compare-live]');

  var behaviorRadar = document.querySelector('.species-radar--behavior');
  var strikeRadar = document.querySelector('.species-radar--strike');
  var habitatRadar = document.querySelector('.species-radar--habitat');
  var fightRadar = document.querySelector('.species-radar--fight');

  var matchupTitleEl = document.querySelector('[data-compare-matchup-title]');
  var matchupSummaryEl = document.querySelector('[data-compare-matchup-summary]');
  var matchupIdentityEl = document.querySelector('[data-compare-matchup-identity]');
  var matchupWrapEl = document.querySelector('.species-compare-output__matchup');
  var matchupVsImgEl = document.querySelector('.species-compare-output__matchupVs img');

  var matchupPrimaryNameEl = document.querySelector('[data-compare-matchup-primary-name]');
  var matchupPrimaryArchetypeEl = document.querySelector('[data-compare-matchup-primary-archetype]');
  var matchupCompareNameEl = document.querySelector('[data-compare-matchup-compare-name]');
  var matchupCompareArchetypeEl = document.querySelector('[data-compare-matchup-compare-archetype]');

  var primaryHeadingEl = document.querySelector('[data-compare-primary-heading]');
  var primaryListEl = document.querySelector('[data-compare-primary-list]');
  var compareHeadingEl = document.querySelector('[data-compare-compare-heading]');
  var compareListEl = document.querySelector('[data-compare-compare-list]');

  var mostSimilarEl = document.querySelector('[data-compare-most-similar]');
  var biggestDifferenceEl = document.querySelector('[data-compare-biggest-difference]');

  var similarPrimaryNameEl = document.querySelector('[data-compare-similar-primary-name]');
  var similarCompareNameEl = document.querySelector('[data-compare-similar-compare-name]');
  var similarPrimaryScoreEl = document.querySelector('[data-compare-similar-primary-score]');
  var similarCompareScoreEl = document.querySelector('[data-compare-similar-compare-score]');
  var similarPrimaryFillEl = document.querySelector('[data-compare-similar-primary-fill]');
  var similarCompareFillEl = document.querySelector('[data-compare-similar-compare-fill]');

  var diffPrimaryNameEl = document.querySelector('[data-compare-difference-primary-name]');
  var diffCompareNameEl = document.querySelector('[data-compare-difference-compare-name]');
  var diffPrimaryScoreEl = document.querySelector('[data-compare-difference-primary-score]');
  var diffCompareScoreEl = document.querySelector('[data-compare-difference-compare-score]');
  var diffPrimaryFillEl = document.querySelector('[data-compare-difference-primary-fill]');
  var diffCompareFillEl = document.querySelector('[data-compare-difference-compare-fill]');

  var directory = [];
  var selected = null;
  var behaviorMatchupMap = {};
  var strikeMatchupMap = {};


  function setStatus(text) {
    if (statusEl) statusEl.textContent = text;
    if (liveRegion) liveRegion.textContent = text;
  }

  function normalize(value) {
    return String(value || '').toLowerCase().trim();
  }

  function closeResults() {
    if (!resultsWrap) return;
    resultsWrap.hidden = true;
    resultsWrap.innerHTML = '';
  }

  function setQuickButtonState(activeItem) {
    quickButtons.forEach(function (button) {
      var btnHandle = button.getAttribute('data-handle') || '';
      var btnTitle = button.getAttribute('data-title') || '';
      var isActive = !!(
        activeItem &&
        (
          (activeItem.handle && btnHandle && activeItem.handle === btnHandle) ||
          (activeItem.title && btnTitle && activeItem.title === btnTitle)
        )
      );
      button.classList.toggle('is-active', isActive);
    });
  }
    function injectCompareNames(text, item) {
    return String(text || '')
      .replace(/\{primary\}/g, currentName || 'Primary')
      .replace(/\{compare\}/g, (item && item.title) || 'Compare');
  }

 function pickFirstText(list, fallback) {
  if (!list || !list.length) return fallback || '';
  for (var i = 0; i < list.length; i++) {
    if (String(list[i] || '').trim()) return String(list[i]).trim();
  }
  return fallback || '';
}

function makePairKey(a, b) {
  return [String(a || '').trim(), String(b || '').trim()]
    .sort(function (left, right) {
      return left.localeCompare(right);
    })
    .join('__');
}

function pickStableVariant(values, seedText) {
  var clean = (values || []).filter(function (value) {
    return String(value || '').trim();
  });

  if (!clean.length) return '';

  var seed = String(seedText || '');
  var hash = 0;

  for (var i = 0; i < seed.length; i++) {
    hash = ((hash << 5) - hash) + seed.charCodeAt(i);
    hash |= 0;
  }

  return clean[Math.abs(hash) % clean.length];
}

function buildMatchupMapsFromRows(rows) {
  var behaviorMap = {};
  var strikeMap = {};

  rows.forEach(function (row) {
    var type = String(getRowValue(row, ['type']) || '').trim().toLowerCase();
    var pairKey = String(getRowValue(row, ['pair_key']) || '').trim();

    if (!type || !pairKey) return;

    var payload = {
      pair_key: pairKey,
      headlines: [
        getRowValue(row, ['headline_1']),
        getRowValue(row, ['headline_2']),
        getRowValue(row, ['headline_3'])
      ].filter(Boolean),
      summaries: [
        getRowValue(row, ['summary_1']),
        getRowValue(row, ['summary_2']),
        getRowValue(row, ['summary_3'])
      ].filter(Boolean),
      primary: [
        getRowValue(row, ['implication_1a']),
        getRowValue(row, ['implication_1b']),
        getRowValue(row, ['implication_1c'])
      ].filter(Boolean),
      compare: [
        getRowValue(row, ['implication_2a']),
        getRowValue(row, ['implication_2b']),
        getRowValue(row, ['implication_2c'])
      ].filter(Boolean)
    };

    if (type === 'behavior') {
      behaviorMap[pairKey] = payload;
    } else if (type === 'strike') {
      strikeMap[pairKey] = payload;
    }
  });

  return {
    behavior: behaviorMap,
    strike: strikeMap
  };
}

function loadMatchupSheet() {
  if (!matchupCsvUrl) {
    return Promise.resolve({ behavior: {}, strike: {} });
  }

  return fetch(matchupCsvUrl)
    .then(function (response) {
      return response.text();
    })
    .then(function (csvText) {
      var rows = parseCsvRows(csvText);
      return buildMatchupMapsFromRows(rows);
    })
    .catch(function (error) {
      console.error('Matchup CSV load failed', error);
      return { behavior: {}, strike: {} };
    });
}

function getMatchupFromSheet(type, archetypeA, archetypeB) {
  var pairKey = makePairKey(archetypeA, archetypeB);
  var map = type === 'strike' ? strikeMatchupMap : behaviorMatchupMap;
  return map[pairKey] || null;
}

function materializeSheetMatchup(row, type, archetypeA, archetypeB, item) {
  if (!row) return null;

  var pairKey = makePairKey(archetypeA, archetypeB);
  var titleSeed = type + '|title|' + pairKey;
  var summarySeed = type + '|summary|' + pairKey;

  return {
    title: pickStableVariant(row.headlines, titleSeed) || (archetypeA + ' vs ' + archetypeB),
    summary: pickStableVariant(row.summaries, summarySeed) || '',
    primary: (row.primary || []).slice(0, 3),
    compare: (row.compare || []).slice(0, 3)
  };
}

var BEHAVIOR_MATCHUP_COPY = {
  'Ambusher__Cruiser': {
    title: 'Ambusher vs Cruiser',
    summary: 'One fish wants to set up and strike from position while the other covers water and hunts on the move.',
    primary: [
      'Slow down and work structure carefully for {primary}',
      'Pick apart high percentage cover instead of burning water',
      'Make repeat casts and let the strike develop'
    ],
    compare: [
      'Cover water faster to locate {compare}',
      'Keep your presentation moving and search aggressively',
      'Do not camp in dead water waiting for action'
    ]
  },

  'Ambusher__Apex': {
  title: 'Ambusher vs Apex',
  summary: 'One fish wins by positioning and patience while the other brings more dominance and force to the fight.',
  primary: [
    'Fish {primary} slowly and stay tight to high percentage cover',
    'Work the ambush lanes instead of covering water too fast',
    'Let precision and setup create the bite'
  ],
  compare: [
    'Fish {compare} with more presence and confidence',
    'Lean into bigger presentations and stronger pressure',
    'Expect a more forceful response once the fish commits'
  ]
},

  'Ambusher__Ambusher': {
    title: 'Ambusher vs Ambusher',
    summary: 'Both fish rely on setup and positioning so this matchup rewards patience and tight structure work.',
    primary: [
      'Work cover slowly and make every cast count for {primary}',
      'Stay tight to structure and fish the high percentage edges',
      'Do not rush the retrieve just to cover more water'
    ],
    compare: [
      'Fish {compare} the same way with slow deliberate presentations',
      'Hit ambush lanes and likely hiding spots repeatedly',
      'Patience matters more than speed in this matchup'
    ]
  },

  'Bully__Cruiser': {
    title: 'Bully vs Cruiser',
    summary: 'One fish pushes the fight with aggression while the other wins by roaming and finding opportunity.',
    primary: [
      'Fish bold and force reactions from {primary}',
      'Lean into heavier pressure and committed presentations',
      'Trigger aggression around structure and high confidence water'
    ],
    compare: [
      'Use movement to find {compare} instead of waiting them out',
      'Keep covering water until you intersect active fish',
      'Search first then dial in once you find them'
    ]
  },

  'Bully__Bully': {
    title: 'Bully vs Bully',
    summary: 'Both species want pressure and presence so this is an aggressive matchup that rewards confidence.',
    primary: [
      'Fish hard and force a response from {primary}',
      'Use presentations that invade the strike zone with authority',
      'Do not get cute when pressure is the better play'
    ],
    compare: [
      'Attack likely water the same way for {compare}',
      'Go with confident presentations and committed hooksets',
      'Aggression beats hesitation in this matchup'
    ]
  }
};

var STRIKE_MATCHUP_COPY = {
  'Sniper__Sniper': {
    summary: 'Both fish demand precision so small mistakes cost you bites.',
    primary: [
      'Dial in casting angle and exact presentation for {primary}',
      'Slow down and make high quality casts instead of more casts',
      'Match depth and cadence carefully'
    ],
    compare: [
      'Fish {compare} with the same precision-first approach',
      'Do not rush retrieves or sloppy presentations',
      'Stay disciplined and let clean execution do the work'
    ]
  },

  'Sniper__Chaotic': {
    summary: 'One fish wants precision while the other will react to speed and disruption.',
    primary: [
      'Keep presentations tight and exact for {primary}',
      'Work the cleanest lane instead of burning water',
      'Let precision create the bite'
    ],
    compare: [
      'Speed up and trigger reaction bites from {compare}',
      'Use movement and change-ups to force a fast decision',
      'Cover water and make the fish react'
    ]
  },

  'Grinder__Bulldozer': {
    summary: 'One fish builds into the bite while the other commits with brute force.',
    primary: [
      'Stay patient and let {primary} load up before forcing the fight',
      'Do not rush the bite just because it feels slow',
      'Keep steady pressure and let the fish commit'
    ],
    compare: [
      'Be ready for a hard commit from {compare}',
      'Set hard and stay tight once the strike happens',
      'Brace for power instead of finesse'
    ]
  },

  'Sprinter__Sprinter': {
    summary: 'Both fish fire fast so this matchup rewards speed and immediate reaction.',
    primary: [
      'Keep {primary} moving fast enough to trigger the strike',
      'Be ready to hit the hookset instantly',
      'Do not let the retrieve die'
    ],
    compare: [
      'Fish {compare} with the same fast-trigger mindset',
      'Use pace and movement to force the decision',
      'React fast because the bite will not wait'
    ]
  }
};

function getBehaviorMatchupCopy(item) {
  if (!item) return null;

  var primaryBehaviorBadge = document.querySelector('[data-archetype-primary-behavior] .species-archetypeBadge__label');
  var compareBehaviorBadge = document.querySelector('[data-archetype-compare-behavior] .species-archetypeBadge__label');

  var primaryBehavior = primaryBehaviorBadge ? primaryBehaviorBadge.textContent.trim() : '';
  var compareBehavior = compareBehaviorBadge ? compareBehaviorBadge.textContent.trim() : '';

  if (!primaryBehavior || !compareBehavior) return null;

  var sheetRow = getMatchupFromSheet('behavior', primaryBehavior, compareBehavior);
var sheetCopy = materializeSheetMatchup(sheetRow, 'behavior', primaryBehavior, compareBehavior, item);
if (sheetCopy) {
  console.log('Behavior matchup from sheet:', primaryBehavior, compareBehavior, sheetCopy);
  return sheetCopy;
}

  var pairKey = makePairKey(primaryBehavior, compareBehavior);
  return BEHAVIOR_MATCHUP_COPY[pairKey] || null;
}

function getStrikeMatchupCopy(item) {
  if (!item) return null;

  var primaryStrikeBadge = document.querySelector('[data-archetype-primary-strike] .species-archetypeBadge__label');
  var compareStrikeBadge = document.querySelector('[data-archetype-compare-strike] .species-archetypeBadge__label');

  var primaryStrike = primaryStrikeBadge ? primaryStrikeBadge.textContent.trim() : '';
  var compareStrike = compareStrikeBadge ? compareStrikeBadge.textContent.trim() : '';

  if (!primaryStrike || !compareStrike) return null;

 var sheetRow = getMatchupFromSheet('strike', primaryStrike, compareStrike);
var sheetCopy = materializeSheetMatchup(sheetRow, 'strike', primaryStrike, compareStrike, item);
if (sheetCopy) {
  console.log('Strike matchup from sheet:', primaryStrike, compareStrike, sheetCopy);
  return sheetCopy;
}

  var pairKey = makePairKey(primaryStrike, compareStrike);
  return STRIKE_MATCHUP_COPY[pairKey] || null;
}

  function renderMatchupIdentity(item) {
  if (!matchupIdentityEl) return;

  if (!item) {
    matchupIdentityEl.textContent = 'No Current Matchup';
    return;
  }

  var primaryBehaviorBadge = document.querySelector('[data-archetype-primary-behavior] .species-archetypeBadge__label');
  var compareBehaviorBadge = document.querySelector('[data-archetype-compare-behavior] .species-archetypeBadge__label');

  var primaryBehavior = primaryBehaviorBadge ? primaryBehaviorBadge.textContent.trim() : '';
  var compareBehavior = compareBehaviorBadge ? compareBehaviorBadge.textContent.trim() : '';

  if (primaryBehavior && compareBehavior) {
    matchupIdentityEl.textContent = primaryBehavior + ' vs ' + compareBehavior;
    return;
  }

  matchupIdentityEl.textContent = currentName + ' vs ' + (item.title || 'Compare');
}

function renderCompareList(listEl, items, item) {
  if (!listEl) return;
  listEl.innerHTML = (items || []).map(function (entry) {
    return '<li>' + injectCompareNames(entry, item) + '</li>';
  }).join('');
}
  function findPrimaryRadarConfig(theme) {
  var selector = theme === 'strike' ? '.species-radar--strike' : '.species-radar--behavior';
  var radar = document.querySelector(selector);
  if (!radar) return null;

  var rawConfig = radar.getAttribute('data-radar-config');
  if (!rawConfig) return null;

  try {
    return JSON.parse(rawConfig);
  } catch (error) {
    console.error('Primary radar config parse failed', error);
    return null;
  }
}

function getAxisMapFromConfig(config) {
  var map = {};
  if (!config || !config.axes) return map;

  var adjustedAxes = getAdjustedAxesForArchetype(config);
  adjustedAxes.forEach(function (axis) {
    if (!axis || !axis.key) return;
    map[axis.key] = {
      key: axis.key,
      label: axis.label,
      value: parseFloat(axis.value) || 0
    };
  });

  return map;
}

function getAxisMapFromCompareData(compareData) {
  var map = {};
  if (!compareData || !compareData.axes) return map;

  compareData.axes.forEach(function (axis) {
    if (!axis || !axis.key) return;
    map[axis.key] = {
      key: axis.key,
      label: axis.label,
      value: parseFloat(axis.value) || 0
    };
  });

  return map;
}

function computeAxisComparisons(primaryMap, compareMap) {
  var results = [];

  Object.keys(primaryMap).forEach(function (key) {
    if (!compareMap[key]) return;

    var a = primaryMap[key].value;
    var b = compareMap[key].value;
    var gap = Math.abs(a - b);
    var averageValue = (a + b) / 2;

    var similarityScore = averageValue - (gap * 2);
    var differenceScore = gap + (Math.max(a, b) * 0.35);

    results.push({
      key: key,
      label: primaryMap[key].label || compareMap[key].label || key,
      a: a,
      b: b,
      gap: gap,
      averageValue: averageValue,
      similarityScore: similarityScore,
      differenceScore: differenceScore
    });
  });

  return results;
}

function getTopSimilarityAndDifference(primaryData, compareData, theme) {
  var primaryConfig = findPrimaryRadarConfig(theme);
  if (!primaryConfig || !compareData) return null;

  var primaryMap = getAxisMapFromConfig(primaryConfig);
  var compareMap = getAxisMapFromCompareData(compareData);

  var comparisons = computeAxisComparisons(primaryMap, compareMap);
  if (!comparisons.length) return null;

  var similaritySorted = comparisons.slice().sort(function (left, right) {
    return right.similarityScore - left.similarityScore;
  });

  var mostSimilar = similaritySorted[0] || null;
  var excludedKey = mostSimilar ? mostSimilar.key : null;

  var differenceSorted = comparisons
    .filter(function (item) {
      return item.key !== excludedKey;
    })
    .sort(function (left, right) {
      return right.differenceScore - left.differenceScore;
    });

  var biggestDifference = differenceSorted[0] || null;

  return {
    mostSimilar: mostSimilar,
    biggestDifference: biggestDifference
  };
}

function formatComparisonStat(item, mode) {
  if (!item) return 'Waiting for matchup data';

  if (mode === 'similar') {
    return item.label + ' (' + Math.round(item.a) + ' vs ' + Math.round(item.b) + ')';
  }

  return item.label + ' (' + Math.round(item.a) + ' vs ' + Math.round(item.b) + ')';
}

function renderMathComparison(item) {
  if (!item || !item.behavior) {
    if (mostSimilarEl) mostSimilarEl.textContent = 'Waiting for matchup data';
    if (biggestDifferenceEl) biggestDifferenceEl.textContent = 'Waiting for matchup data';
    return;
  }

  var behaviorResult = getTopSimilarityAndDifference(null, item.behavior, 'behavior');

  if (mostSimilarEl) {
    mostSimilarEl.textContent = behaviorResult && behaviorResult.mostSimilar
      ? formatComparisonStat(behaviorResult.mostSimilar, 'similar')
      : 'Waiting for matchup data';
  }

  if (biggestDifferenceEl) {
    biggestDifferenceEl.textContent = behaviorResult && behaviorResult.biggestDifference
      ? formatComparisonStat(behaviorResult.biggestDifference, 'difference')
      : 'Waiting for matchup data';
  }
}


  function clearComparisonOutput() {
    if (matchupIdentityEl) matchupIdentityEl.textContent = 'No Current Matchup';
    if (matchupTitleEl) matchupTitleEl.textContent = 'No Current Matchup';
    if (matchupSummaryEl) matchupSummaryEl.textContent = 'Choose a species to generate strategy insights';
    if (mostSimilarEl) mostSimilarEl.textContent = 'Waiting for matchup data';
if (biggestDifferenceEl) biggestDifferenceEl.textContent = 'Waiting for matchup data';

    if (primaryHeadingEl) primaryHeadingEl.textContent = 'Play ' + currentName + ' Like This';
    if (compareHeadingEl) compareHeadingEl.textContent = 'Play Compare Like This';

    if (primaryListEl) {
      primaryListEl.innerHTML = ''
        + '<li>Pick a species to load matchup strategy</li>'
        + '<li>Primary tactics will appear here</li>'
        + '<li>Comparison-specific advice will populate here</li>';
    }

    if (compareListEl) {
      compareListEl.innerHTML = ''
        + '<li>Select a species from search or quick buttons</li>'
        + '<li>Compare tactics will appear here</li>'
        + '<li>Use the radar plus strategy together</li>';
    }
  }
  function refreshMatchupHeaderMotion() {
  if (!matchupWrapEl) return;

  matchupWrapEl.classList.remove('is-refreshing');
  void matchupWrapEl.offsetWidth;
  matchupWrapEl.classList.add('is-refreshing');

  window.setTimeout(function () {
    if (matchupWrapEl) matchupWrapEl.classList.remove('is-refreshing');
  }, 260);
}
function refreshMatchupHeaderMotion() {
  if (!matchupWrapEl) return;

  matchupWrapEl.classList.remove('is-refreshing');
  void matchupWrapEl.offsetWidth;
  matchupWrapEl.classList.add('is-refreshing');

  window.setTimeout(function () {
    if (matchupWrapEl) matchupWrapEl.classList.remove('is-refreshing');
  }, 260);
}

function spinMatchupVs() {
  if (!matchupWrapEl || !matchupVsImgEl) return;

  matchupWrapEl.classList.remove('is-spinning');
  void matchupWrapEl.offsetWidth;
  matchupWrapEl.classList.add('is-spinning');

  window.setTimeout(function () {
    if (matchupWrapEl) matchupWrapEl.classList.remove('is-spinning');
  }, 950);
}

function parseCompareMetricText(text) {
  var raw = String(text || '').trim();
  var match = raw.match(/^(.*?)\s*\(([\d.]+)\s+vs\s+([\d.]+)\)$/i);

  if (!match) {
    return {
      label: raw,
      primary: 0,
      compare: 0
    };
  }

  return {
    label: String(match[1] || '').trim(),
    primary: Math.max(0, Math.min(100, parseFloat(match[2] || '0') || 0)),
    compare: Math.max(0, Math.min(100, parseFloat(match[3] || '0') || 0))
  };
}

function updateInsightMeters(item) {
  var primaryName = currentName || 'Primary Species';
  var compareName = (item && item.title) || 'Compare Species';

  if (similarPrimaryNameEl) similarPrimaryNameEl.textContent = primaryName;
  if (similarCompareNameEl) similarCompareNameEl.textContent = compareName;
  if (diffPrimaryNameEl) diffPrimaryNameEl.textContent = primaryName;
  if (diffCompareNameEl) diffCompareNameEl.textContent = compareName;

  if (mostSimilarEl) {
    var similarMetric = parseCompareMetricText(mostSimilarEl.textContent);
    mostSimilarEl.textContent = similarMetric.label || 'Waiting for matchup data';

    if (similarPrimaryScoreEl) similarPrimaryScoreEl.textContent = String(Math.round(similarMetric.primary));
    if (similarCompareScoreEl) similarCompareScoreEl.textContent = String(Math.round(similarMetric.compare));
    if (similarPrimaryFillEl) similarPrimaryFillEl.style.width = similarMetric.primary + '%';
    if (similarCompareFillEl) similarCompareFillEl.style.width = similarMetric.compare + '%';
  }

  if (biggestDifferenceEl) {
    var diffMetric = parseCompareMetricText(biggestDifferenceEl.textContent);
    biggestDifferenceEl.textContent = diffMetric.label || 'Waiting for matchup data';

    if (diffPrimaryScoreEl) diffPrimaryScoreEl.textContent = String(Math.round(diffMetric.primary));
    if (diffCompareScoreEl) diffCompareScoreEl.textContent = String(Math.round(diffMetric.compare));
    if (diffPrimaryFillEl) diffPrimaryFillEl.style.width = diffMetric.primary + '%';
    if (diffCompareFillEl) diffCompareFillEl.style.width = diffMetric.compare + '%';
  }
}
function updateMatchupHeader(item, identityText) {
  var fallbackIdentity = 'Waiting for matchup';
  var primaryName = currentName || 'Primary Species';
  var compareName = (item && item.title) || 'Compare Species';
  var leftArch = fallbackIdentity;
  var rightArch = fallbackIdentity;

  var cleanIdentity = String(identityText || '').trim();

  if (cleanIdentity && cleanIdentity !== 'No Current Matchup') {
    var parts = cleanIdentity.split(/\s+vs\s+/i);
    if (parts.length >= 2) {
      leftArch = String(parts[0] || '').trim() || fallbackIdentity;
      rightArch = String(parts[1] || '').trim() || fallbackIdentity;
    } else {
      leftArch = cleanIdentity;
      rightArch = cleanIdentity;
    }
  }

  if (matchupPrimaryNameEl) matchupPrimaryNameEl.textContent = primaryName;
  if (matchupCompareNameEl) matchupCompareNameEl.textContent = compareName;
  if (matchupPrimaryArchetypeEl) matchupPrimaryArchetypeEl.textContent = leftArch;
  if (matchupCompareArchetypeEl) matchupCompareArchetypeEl.textContent = rightArch;

  if (primaryHeadingEl) primaryHeadingEl.textContent = primaryName + ' Advice';
  if (compareHeadingEl) compareHeadingEl.textContent = compareName + ' Advice';
}

  function renderComparisonOutput(item) {
  if (!item) {
    clearComparisonOutput();
    return;
  }

  renderMatchupIdentity(item);
  renderMathComparison(item);

  var behaviorCopy = getBehaviorMatchupCopy(item);
  var strikeCopy = getStrikeMatchupCopy(item);
  var copy = item.comparison_copy || {};

  var fallbackSummary = pickFirstText(copy.summaries, currentName + ' vs ' + item.title);
  var fallbackPrimary = (copy.primary_implications || []).slice(0, 3);
  var fallbackCompare = (copy.compare_implications || []).slice(0, 3);

  var summaryParts = [];
  if (behaviorCopy && behaviorCopy.summary) summaryParts.push(behaviorCopy.summary);
  if (strikeCopy && strikeCopy.summary) summaryParts.push(strikeCopy.summary);

  var primaryItems = [];
var compareItems = [];

/* Prefer the behavior matchup sheet copy first */
if (behaviorCopy && behaviorCopy.primary && behaviorCopy.primary.length) {
  primaryItems = behaviorCopy.primary.slice(0, 3);
}
if (behaviorCopy && behaviorCopy.compare && behaviorCopy.compare.length) {
  compareItems = behaviorCopy.compare.slice(0, 3);
}

/* Fall back to strike copy only if behavior copy is missing */
if (!primaryItems.length && strikeCopy && strikeCopy.primary && strikeCopy.primary.length) {
  primaryItems = strikeCopy.primary.slice(0, 3);
}
if (!compareItems.length && strikeCopy && strikeCopy.compare && strikeCopy.compare.length) {
  compareItems = strikeCopy.compare.slice(0, 3);
}

/* Final fallback to raw comparison_copy */
if (!primaryItems.length) primaryItems = fallbackPrimary;
if (!compareItems.length) compareItems = fallbackCompare;

  var summaryText = summaryParts.length ? summaryParts.join(' ') : fallbackSummary;
  var titleText = (behaviorCopy && behaviorCopy.title)
    ? behaviorCopy.title
    : (currentName + ' vs ' + item.title);

  if (matchupTitleEl) matchupTitleEl.textContent = titleText;
  if (matchupSummaryEl) matchupSummaryEl.textContent = injectCompareNames(summaryText, item);
  var identityText = matchupIdentityEl ? matchupIdentityEl.textContent : '';
updateMatchupHeader(item, identityText);
updateInsightMeters(item);
refreshMatchupHeaderMotion();
spinMatchupVs();


  renderCompareList(primaryListEl, primaryItems, item);
  renderCompareList(compareListEl, compareItems, item);
}


function updateSelectionUI(item) {
  if (!item) {
    if (selectionName) selectionName.textContent = 'No Current Comparison';
    if (selectionScientific) {
      selectionScientific.textContent = 'Choose a species below to compare';
      selectionScientific.style.display = '';
    }
    if (selectionActions) selectionActions.hidden = true;
    if (selectionWrap) selectionWrap.classList.remove('is-active');

    if (selectionLink) {
      selectionLink.setAttribute('href', '#');
      selectionLink.style.pointerEvents = 'none';
      selectionLink.style.opacity = '.5';
    }

    if (clearBtn) clearBtn.hidden = true;
clearComparisonOutput();
updateMatchupHeader(null, '');
updateInsightMeters(null);
refreshMatchupHeaderMotion();
spinMatchupVs();

hideCompareBadge();
setQuickButtonState(null);
setStatus('No comparison species selected');
return;
  }

  if (selectionName) selectionName.textContent = item.title || '';

  if (selectionScientific) {
    selectionScientific.textContent = item.scientific_name || '';
    selectionScientific.style.display = item.scientific_name ? '' : 'none';
  }

  if (selectionActions) selectionActions.hidden = false;
  if (selectionWrap) selectionWrap.classList.add('is-active');

  if (selectionLink) {
    selectionLink.setAttribute('href', item.url || '#');
    selectionLink.style.pointerEvents = item.url ? '' : 'none';
    selectionLink.style.opacity = item.url ? '' : '.5';
  }

  if (clearBtn) clearBtn.hidden = false;

  showCompareBadge(item);
  setQuickButtonState(item);
  setStatus('Comparing ' + currentName + ' vs ' + (item.title || 'selected species'));
  renderComparisonOutput(item);
}

   function clearSelection() {
    selected = null;

    if (searchInput) searchInput.value = '';

    clearRadarOverlay(behaviorRadar);
    clearRadarOverlay(strikeRadar);
    clearRadarOverlay(habitatRadar);
    clearRadarOverlay(fightRadar);
    updateSelectionUI(null);
    closeResults();
  }

  function applySelection(item, source) {
    if (!item) return;

    selected = item;
    console.log('DESKTOP COMPARE ITEM:', item);
console.log('Behavior:', item.behavior);
console.log('Strike:', item.strike);
console.log('Habitat:', item.habitat);
console.log('Fight:', item.fight);

    if (searchInput) {
      searchInput.value = item.title || '';
    }

    updateSelectionUI(item);
    closeResults();

    if (item.behavior) item.behavior.handle = item.handle || '';
if (item.strike) item.strike.handle = item.handle || '';
if (item.habitat) item.habitat.handle = item.handle || '';
if (item.fight) item.fight.handle = item.handle || '';

renderRadarOverlay(behaviorRadar, item.behavior);
renderRadarOverlay(strikeRadar, item.strike);
renderRadarOverlay(habitatRadar, item.habitat);
renderRadarOverlay(fightRadar, item.fight);

    compareRoot.setAttribute('data-compare-source', source || 'unknown');
  }

  function findMatches(query) {
    var q = normalize(query);
    if (!q) return [];

    return directory
      .filter(function (item) {
        if (!item || !item.title || !item.url) return false;
        if (item.url === currentUrl) return false;

        var title = normalize(item.title);
        var sci = normalize(item.scientific_name);

        return title.indexOf(q) !== -1 || sci.indexOf(q) !== -1;
      })
      .sort(function (a, b) {
        var aStarts = normalize(a.title).indexOf(q) === 0 ? 0 : 1;
        var bStarts = normalize(b.title).indexOf(q) === 0 ? 0 : 1;
        if (aStarts !== bStarts) return aStarts - bStarts;
        return String(a.title || '').localeCompare(String(b.title || ''));
      })
      .slice(0, 8);
  }

  function renderResults(items) {
    if (!resultsWrap) return;

    if (!items.length) {
      resultsWrap.innerHTML = '<div class="species-command-compare__resultEmpty">No matching species found</div>';
      resultsWrap.hidden = false;
      return;
    }

    resultsWrap.innerHTML = items.map(function (item, index) {
      return ''
        + '<button type="button" class="species-command-compare__result" data-result-index="' + index + '">'
        +   '<div class="species-command-compare__resultName">' + (item.title || '') + '</div>'
        +   '<div class="species-command-compare__resultScientific">' + (item.scientific_name || '') + '</div>'
        + '</button>';
    }).join('');

    resultsWrap.hidden = false;

    Array.prototype.slice.call(resultsWrap.querySelectorAll('[data-result-index]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var index = parseInt(button.getAttribute('data-result-index'), 10);
        var item = items[index];
        if (!item) return;
        maybeApplySelection(item, 'search');
      });
    });
  }

  function findByHandleOrTitle(handle, title) {
    var normalizedHandle = normalize(handle);
    var normalizedTitle = normalize(title);

    var exactHandle = directory.find(function (item) {
      return normalize(item.handle) === normalizedHandle;
    });
    if (exactHandle) return exactHandle;

    var exactTitle = directory.find(function (item) {
      return normalize(item.title) === normalizedTitle;
    });
    if (exactTitle) return exactTitle;

    return null;
  }

 var mobileCompareApiBase = 'https://script.google.com/macros/s/AKfycbwrDFbBf8dtpRbWuTiwhCP7cp3gyOBGi3IvXsK0LYJ41kYk5RYxLv9IvtgwXSnZaLg3/exec';

function extractCompareHandle(value) {
  var clean = String(value || '').trim();
  clean = clean.split('?')[0].split('#')[0].replace(/\/$/, '');
  return clean.split('/').pop();
}


function loadSingleCompareSpecies(handle, title) {
  if (!handle) return Promise.resolve(null);

  var cleanHandle = extractCompareHandle(handle);
var url = mobileCompareApiBase + '?mode=compare_species&handle=' + encodeURIComponent(cleanHandle);

  return fetch(url)
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      if (!data || data.error) {
        console.warn('Single compare species lookup failed', data && data.error, handle);
        return null;
      }

      return {
        title: data.title || title || '',
        scientific_name: data.scientific_name || '',
        url: data.url || '',
        handle: data.url || data.handle || cleanHandle,
        image: data.image || '',
        comparison_copy: {
          headlines: [],
          summaries: [],
          primary_implications: [],
          compare_implications: []
        },
        behavior: data.behavior_json ? JSON.parse(data.behavior_json) : null,
        strike: data.strike_json ? JSON.parse(data.strike_json) : null,
        habitat: data.habitat_json ? JSON.parse(data.habitat_json) : null,
        fight: data.fight_json ? JSON.parse(data.fight_json) : null
      };
    })
    .catch(function (error) {
      console.error('Single compare species fetch failed', error);
      return null;
    });
}

function maybeApplySelection(item, source) {
  if (!item) return;

  if (!isMobileCompare) {
    applySelection(item, source);
    return;
  }

  setStatus('Loading comparison for ' + (item.title || 'selected species') + '...');

  loadSingleCompareSpecies(item.handle, item.title).then(function (fullItem) {
    if (fullItem && fullItem.behavior && fullItem.strike && fullItem.habitat && fullItem.fight) {
      applySelection(fullItem, source);
    } else {
  console.warn('Mobile compare payload missing. Not rendering fallback item.', item);
  setStatus('Comparison data unavailable for ' + (item.title || 'selected species'));
  return;
}
  });
}

function loadDirectoryFromCsv() {
  if (csvUrl) {
    return fetch(csvUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (csvText) {
        var rows = parseCsvRows(csvText);

        return rows
          .map(buildComparePayloadFromRow)
          .filter(function (item) {
            return item && item.title && item.url;
          })
          .filter(function (item) {
            return item.url !== currentUrl && normalize(item.handle) !== normalize(currentHandle);
          });
      })
      .catch(function (error) {
        console.error('Comparison CSV load failed', error);

        var inlineDirectoryEl = compareRoot.querySelector('[data-species-compare-directory]');
        if (inlineDirectoryEl) {
          try {
            var inlineItems = JSON.parse(inlineDirectoryEl.textContent || '[]');
            return inlineItems
              .filter(function (item) {
                return item && item.title && item.url;
              })
              .filter(function (item) {
                return item.url !== currentUrl && normalize(item.handle) !== normalize(currentHandle);
              });
          } catch (inlineError) {
            console.error('Inline comparison directory parse failed', inlineError);
          }
        }

        return [];
      });
  }

  var inlineDirectoryEl = compareRoot.querySelector('[data-species-compare-directory]');
  if (inlineDirectoryEl) {
    try {
      var inlineItems = JSON.parse(inlineDirectoryEl.textContent || '[]');
      return Promise.resolve(
        inlineItems
          .filter(function (item) {
            return item && item.title && item.url;
          })
          .filter(function (item) {
            return item.url !== currentUrl && normalize(item.handle) !== normalize(currentHandle);
          })
      );
    } catch (error) {
      console.error('Inline comparison directory parse failed', error);
    }
  }

  return Promise.resolve([]);
}

function appendExtraSpeciesCards() {
  var container = compareRoot.querySelector('.species-command-compare__right');
  if (!container || !directory.length) return;

  var existingHandles = Array.prototype.map.call(
    container.querySelectorAll('[data-species-handle]'),
    function (el) {
      return String(el.getAttribute('data-species-handle') || '').trim();
    }
  );

  var pool = directory.filter(function (item) {
    var handle = String(item.handle || '').trim();
    return (
      handle &&
      handle !== currentHandle &&
      existingHandles.indexOf(handle) === -1
    );
  });

  for (var i = pool.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = pool[i];
    pool[i] = pool[j];
    pool[j] = temp;
  }

  var extras = pool.slice(0, 6);

  extras.forEach(function (item) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'species-command-compare__quickBtn';
    button.setAttribute('data-compare-quick', '');
    button.setAttribute('data-handle', item.handle || '');
    button.setAttribute('data-species-handle', item.handle || '');
    button.setAttribute('data-title', item.title || '');

   button.innerHTML =
  '<div class="species-command-compare__quickImage" style="background-image:url(\'' +
  (item.image || '') +
  '\');"></div>' +
  '<span class="species-command-compare__quickBtnText">' +
  (item.title || 'Unknown Species') +
  '</span>';

    button.addEventListener('click', function () {
      var clickedHandle = button.getAttribute('data-handle') || '';
      var clickedTitle = button.getAttribute('data-title') || '';
      var foundItem = findByHandleOrTitle(clickedHandle, clickedTitle);
      if (!foundItem) return;
      maybeApplySelection(foundItem, 'extra');
    });

    container.appendChild(button);
  });
}
Promise.all([
  loadDirectoryFromCsv(),
  loadMatchupSheet()
]).then(function (results) {
  directory = results[0] || [];

  var matchupMaps = results[1] || {};
  behaviorMatchupMap = matchupMaps.behavior || {};
  strikeMatchupMap = matchupMaps.strike || {};

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = searchInput.value || '';
      if (!query.trim()) {
        closeResults();
        return;
      }
      renderResults(findMatches(query));
    });

    searchInput.addEventListener('focus', function () {
      var query = searchInput.value || '';
      if (!query.trim()) return;
      renderResults(findMatches(query));
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeResults();
      }
    });
  }

  if (randomBtn) {
    randomBtn.addEventListener('click', function () {
      if (!directory.length) return;

      var pool = directory.slice();

      if (selected && selected.url) {
        var filtered = pool.filter(function (item) {
          return item.url !== selected.url;
        });
        if (filtered.length) pool = filtered;
      }

      var randomItem = pool[Math.floor(Math.random() * pool.length)];
      maybeApplySelection(randomItem, 'random');
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      clearSelection();
      if (searchInput) searchInput.focus();
    });
  }

  if (selectionRemove) {
    selectionRemove.addEventListener('click', function () {
      clearSelection();
    });
  }

  quickButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      if (button.disabled) return;

      var handle = button.getAttribute('data-handle') || '';
      var title = button.getAttribute('data-title') || '';
      var item = findByHandleOrTitle(handle, title);

      if (!item) return;

      maybeApplySelection(item, 'related');
    });
  });

  document.addEventListener('click', function (e) {
    if (!compareRoot.contains(e.target)) {
      closeResults();
    }
  });

     appendExtraSpeciesCards();
  updateSelectionUI(null);
  clearComparisonOutput();
});
}

function recheckCollapsibles() {
    var collapsibles = document.querySelectorAll('[data-collapsible]');
    collapsibles.forEach(function (block) {
      var content = block.querySelector('[data-collapsible-content]');
      var toggle = block.querySelector('[data-collapsible-toggle]');
      var lines = parseInt(block.getAttribute('data-clamp-lines'), 10) || 3;

      if (!content || !toggle) return;

      if (!contentNeedsClamp(content, lines)) {
        toggle.hidden = true;
        toggle.setAttribute('aria-hidden', 'true');
        block.classList.remove('is-collapsed', 'is-expanded');
        content.classList.remove('is-collapsed', 'is-expanded');
      } else {
        toggle.hidden = false;
        toggle.removeAttribute('aria-hidden');
        if (!block.classList.contains('is-expanded')) {
          setToggleState(block, false);
        }
      }
    });
  }

  function initRelatedSpeciesScoreHover() {
    var cards = document.querySelectorAll('.species-related__item');

    cards.forEach(function (card) {
      var scoreEl = card.querySelector('[data-target-score]');
      if (!scoreEl) return;

      var target = parseInt(scoreEl.getAttribute('data-target-score'), 10) || 0;
      if (target <= 0) return;

      var animated = false;
      var frameId = null;

      function runCountUp() {
        if (animated) return;
        animated = true;

        var duration = 850;
        var startTime = null;

        scoreEl.classList.add('is-animating');
        scoreEl.textContent = '00';

        function step(timestamp) {
          if (!startTime) startTime = timestamp;

          var progress = Math.min((timestamp - startTime) / duration, 1);
          var current = Math.round(target * progress);

          scoreEl.textContent = String(current).padStart(2, '0');

          if (progress < 1) {
            frameId = window.requestAnimationFrame(step);
          }
        }

        frameId = window.requestAnimationFrame(step);
      }

      function resetCount() {
        if (frameId) {
          window.cancelAnimationFrame(frameId);
          frameId = null;
        }

        animated = false;
        scoreEl.classList.remove('is-animating');
        scoreEl.textContent = '00';
      }

      card.addEventListener('mouseenter', runCountUp);
      card.addEventListener('mouseleave', resetCount);
      card.addEventListener('focusin', runCountUp);
      card.addEventListener('focusout', resetCount);
    });
  }
/* ============================================
   Archetype engine
   ============================================ */

var BEHAVIOR_ARCHETYPES = [
  {
    name: 'Ambusher',
    positive: { aggression: 1.2, structure_dependence: 1.45 },
    negative: { roaming_behavior: 1.1, schooling_behavior: 0.5 }
  },
  {
    name: 'Bully',
    positive: { aggression: 1.45, fight_intensity: 1.05, structure_dependence: 0.7 },
    negative: { wariness: 0.25 }
  },
  {
    name: 'Schooler',
    positive: { schooling_behavior: 1.75, roaming_behavior: 0.35, feeding_windows: 0.25 }
  },
  {
    name: 'Stalker',
    positive: { wariness: 1.2, roaming_behavior: 1.0, aggression: 0.35 },
    negative: { schooling_behavior: 0.65 }
  },
  {
    name: 'Dweller',
    positive: { structure_dependence: 1.8 },
    negative: { roaming_behavior: 1.25, surface_feeding: 0.45 }
  },
  {
    name: 'Cruiser',
    positive: { roaming_behavior: 1.7, surface_feeding: 0.25 },
    negative: { structure_dependence: 1.0 }
  },
  {
    name: 'Grubber',
    positive: { feeding_windows: 0.55 },
    negative: { aggression: 1.15, roaming_behavior: 0.95, surface_feeding: 1.1 }
  },
  {
    name: 'Trigger',
    positive: { feeding_windows: 1.55, aggression: 0.7, surface_feeding: 0.45 }
  },
  {
    name: 'Opportunist',
    positive: { feeding_windows: 1.0, roaming_behavior: 0.65, schooling_behavior: 0.35, surface_feeding: 0.25 }
  },
  {
    name: 'Apex',
    positive: { aggression: 1.2, fight_intensity: 1.2, roaming_behavior: 0.95 },
    negative: { schooling_behavior: 0.45 }
  },
  {
    name: 'Pack Hunter',
    positive: { schooling_behavior: 1.35, aggression: 0.9, roaming_behavior: 0.7 }
  },
  {
    name: 'Nomad',
    positive: { roaming_behavior: 1.45, feeding_windows: 1.05 },
    negative: { structure_dependence: 0.75 }
  }
];

var STRIKE_ARCHETYPES = [
  {
    name: 'Sprinter',
    positive: { strike_speed: 1.7, reaction_bias: 1.05, trigger_sensitivity: 0.5 },
    negative: { strike_commitment: 0.25 }
  },
  {
    name: 'Grinder',
    positive: { strike_commitment: 1.15, presentation_precision: 0.55, selectivity: 0.35 },
    negative: { reaction_bias: 0.25 }
  },
  {
    name: 'Screamer',
    positive: { strike_speed: 1.35, strike_commitment: 0.95, reaction_bias: 0.55 }
  },
  {
    name: 'Shaker',
    positive: { reaction_bias: 1.05, strike_commitment: 0.65, selectivity: 0.4 }
  },
  {
    name: 'Acrobat',
    positive: { strike_speed: 1.15, reaction_bias: 1.2, trigger_sensitivity: 0.75 }
  },
  {
    name: 'Sniper',
    positive: { presentation_precision: 1.35, stealth_requirement: 1.1, selectivity: 0.9 },
    negative: { opportunistic_feeding: 0.45 }
  },
  {
    name: 'Teaser',
    positive: { selectivity: 1.3, stealth_requirement: 0.8 },
    negative: { strike_commitment: 1.0, trigger_sensitivity: 0.25 }
  },
  {
    name: 'Rattler',
    positive: { reaction_bias: 1.45, trigger_sensitivity: 1.0, strike_speed: 0.55 },
    negative: { strike_commitment: 0.45 }
  },
  {
    name: 'Bulldozer',
    positive: { strike_commitment: 1.5, opportunistic_feeding: 0.35 },
    negative: { strike_speed: 0.55 }
  },
  {
    name: 'Raider',
    positive: { strike_speed: 1.15, opportunistic_feeding: 1.0, trigger_sensitivity: 0.55 },
    negative: { presentation_precision: 0.4 }
  },
  {
    name: 'Chaotic',
    positive: { reaction_bias: 1.25, strike_speed: 1.1, opportunistic_feeding: 0.75 },
    negative: { presentation_precision: 0.55 }
  },
  {
    name: 'Torque',
    positive: { strike_commitment: 1.35, presentation_precision: 0.65, stealth_requirement: 0.55, selectivity: 0.4 },
    negative: { reaction_bias: 0.3 }
  }
];

function getTopScore(scores) {
  var topKey = null;
  var topVal = -Infinity;

  Object.keys(scores).forEach(function (key) {
    if (scores[key] > topVal) {
      topVal = scores[key];
      topKey = key;
    }
  });

  return topKey;
}

function getPositioningArchetype(data){
  if (!data || !data.axes) return null;

  var v = {};
  data.axes.forEach(function(a){ v[a.key] = Number(a.value || 0); });

  var scores = {
    pocket:
      (v.ambush_positioning * 0.35) +
      (v.cover_dependency * 0.25) +
      (v.structure_affinity * 0.2) +
      (v.zone_specificity * 0.2) -
      (v.roaming_behavior * 0.2),

    anchor:
      (v.structure_affinity * 0.4) +
      (v.cover_dependency * 0.25) +
      (v.depth_preference * 0.15) +
      (v.zone_specificity * 0.2),

    seam:
      (v.current_dependency * 0.4) +
      (v.zone_specificity * 0.3) +
      (v.structure_affinity * 0.15) +
      (v.roaming_behavior * 0.1),

    bluewater:
      (v.roaming_behavior * 0.4) +
      (v.vertical_mobility * 0.3) -
      (v.cover_dependency * 0.2) -
      (v.structure_affinity * 0.2),

    benthic:
      (v.depth_preference * 0.45) +
      (v.structure_affinity * 0.25) -
      (v.vertical_mobility * 0.2),

    drifter:
      (v.roaming_behavior * 0.35) +
      (v.vertical_mobility * 0.25) -
      (v.zone_specificity * 0.25)
  };

  return getTopScore(scores);
}
function getFightArchetype(data){
  if (!data || !data.axes) return null;

  var v = {};
  data.axes.forEach(function(a){ v[a.key] = Number(a.value || 0); });

  var scores = {
    workhorse:
      (v.initial_run_power * 0.25) +
      (v.endurance * 0.3) +
      (v.line_stress * 0.25) +
      (v.control_resistance * 0.2),

    digger:
      (v.control_resistance * 0.35) +
      (v.landing_difficulty * 0.3) +
      (v.recovery_bursts * 0.2) +
      (v.line_stress * 0.15),

    acrobat:
      (v.aerial_behavior * 0.45) +
      (v.directional_chaos * 0.3) +
      (v.landing_difficulty * 0.25),

    speed_demon:
      (v.initial_run_power * 0.5) +
      (v.directional_chaos * 0.2) -
      (v.endurance * 0.2),

    scrapper:
      (v.directional_chaos * 0.3) +
      (v.recovery_bursts * 0.3) +
      (v.control_resistance * 0.2) +
      (v.initial_run_power * 0.2),

    tugboat:
      (v.endurance * 0.4) +
      (v.line_stress * 0.3) -
      (v.aerial_behavior * 0.2) -
      (v.directional_chaos * 0.1)
  };

  return getTopScore(scores);
}

function getPositioningArchetypeFromAxes(axes) {
  return getPositioningArchetype({ axes: axes || [] }) || 'Drifter';
}

function getFightArchetypeFromAxes(axes) {
  return getFightArchetype({ axes: axes || [] }) || 'Scrapper';
}

function getPositioningArchetypeFromConfig(config) {
  return getPositioningArchetypeFromAxes(getAdjustedAxesForArchetype(config));
}

function getFightArchetypeFromConfig(config) {
  return getFightArchetypeFromAxes(getAdjustedAxesForArchetype(config));
}

function buildAxisValueMap(axes) {
  var map = {};
  (axes || []).forEach(function (axis) {
    if (!axis || !axis.key) return;
    map[axis.key] = clamp(parseFloat(axis.value) || 0, 0, 100);
  });
  return map;
}

function getAxisValue(axes, key) {
  var found = axes.find(function(a) { return a.key === key; });
  return found ? Number(found.value) : 0;
}

function getAdjustedAxesForArchetype(config) {
  if (!config || !config.axes) return [];
  var maxValue = config.max || 100;
  var speciesHandle = config.handle || '';

  return config.axes.map(function (axis) {
    var baseValue = parseFloat(axis.value) || 0;
    var offset = getStableAxisOffset(speciesHandle, axis.key);
    return {
      key: axis.key,
      label: axis.label,
      value: clamp(baseValue + offset, 0, maxValue)
    };
  });
}

function scoreArchetype(definition, values) {
  var score = 0;
  var positive = definition.positive || {};
  var negative = definition.negative || {};

  Object.keys(positive).forEach(function (key) {
    score += (values[key] || 0) * positive[key];
  });

  Object.keys(negative).forEach(function (key) {
    score += (100 - (values[key] || 0)) * negative[key];
  });

  return score;
}

function pickArchetype(axes, definitions, fallbackName) {
  var values = buildAxisValueMap(axes);
  var bestName = fallbackName || 'Unknown';
  var bestScore = -Infinity;

  definitions.forEach(function (definition) {
    var score = scoreArchetype(definition, values);
    if (score > bestScore) {
      bestScore = score;
      bestName = definition.name;
    }
  });

  return bestName;
}

function getBehaviorArchetypeFromAxes(axes) {
  return pickArchetype(axes, BEHAVIOR_ARCHETYPES, 'Opportunist');
}

function getStrikeArchetypeFromAxes(axes) {
  return pickArchetype(axes, STRIKE_ARCHETYPES, 'Grinder');
}

function getBehaviorArchetypeFromConfig(config) {
  return getBehaviorArchetypeFromAxes(getAdjustedAxesForArchetype(config));
}

function getStrikeArchetypeFromConfig(config) {
  return getStrikeArchetypeFromAxes(getAdjustedAxesForArchetype(config));
}

function initArchetypeBadges() {
  var primaryBehaviorBadge = document.querySelector('[data-archetype-primary-behavior]');
  var primaryStrikeBadge = document.querySelector('[data-archetype-primary-strike]');
  var primaryPositioningBadge = document.querySelector('[data-archetype-primary-positioning]');
  var primaryFightBadge = document.querySelector('[data-archetype-primary-fight]');

  var behaviorRadar = document.querySelector('.species-radar--behavior');
  var strikeRadar = document.querySelector('.species-radar--strike');
  var habitatRadar = document.querySelector('.species-radar--habitat');
  var fightRadar = document.querySelector('.species-radar--fight');

    if (primaryPositioningBadge && habitatRadar) {
    var positioningLabel = primaryPositioningBadge.querySelector('.species-archetypeBadge__label');
    var rawHabitatConfig = habitatRadar.getAttribute('data-radar-config');

    if (positioningLabel && rawHabitatConfig) {
      try {
        var habitatConfig = JSON.parse(rawHabitatConfig);
        var positioningText = getPositioningArchetypeFromConfig(habitatConfig);
        positioningLabel.textContent = positioningText;
        autoSizeArchetypeText(positioningLabel, positioningText);
      } catch (error) {
        positioningLabel.textContent = 'Positioning';
        autoSizeArchetypeText(positioningLabel, 'Positioning');
      }
    }

    window.setTimeout(function () {
      primaryPositioningBadge.classList.add('is-intro');
    }, 500);
  }

  if (primaryFightBadge && fightRadar) {
    var fightLabel = primaryFightBadge.querySelector('.species-archetypeBadge__label');
    var rawFightConfig = fightRadar.getAttribute('data-radar-config');

    if (fightLabel && rawFightConfig) {
      try {
        var fightConfig = JSON.parse(rawFightConfig);
        var fightText = getFightArchetypeFromConfig(fightConfig);
        fightLabel.textContent = fightText;
        autoSizeArchetypeText(fightLabel, fightText);
      } catch (error) {
        fightLabel.textContent = 'Fight';
        autoSizeArchetypeText(fightLabel, 'Fight');
      }
    }

    window.setTimeout(function () {
      primaryFightBadge.classList.add('is-intro');
    }, 620);
  }

 

  if (primaryBehaviorBadge && behaviorRadar) {
    var behaviorLabel = primaryBehaviorBadge.querySelector('.species-archetypeBadge__label');
    var rawBehaviorConfig = behaviorRadar.getAttribute('data-radar-config');

    if (behaviorLabel && rawBehaviorConfig) {
      try {
        var behaviorConfig = JSON.parse(rawBehaviorConfig);
        var behaviorText = getBehaviorArchetypeFromConfig(behaviorConfig);
        behaviorLabel.textContent = behaviorText;
        autoSizeArchetypeText(behaviorLabel, behaviorText);
      } catch (error) {
        behaviorLabel.textContent = 'Behavior';
        autoSizeArchetypeText(behaviorLabel, 'Behavior');
      }
    }

    window.setTimeout(function () {
      primaryBehaviorBadge.classList.add('is-intro');
    }, 260);
  }

  if (primaryStrikeBadge && strikeRadar) {
    var strikeLabel = primaryStrikeBadge.querySelector('.species-archetypeBadge__label');
    var rawStrikeConfig = strikeRadar.getAttribute('data-radar-config');

    if (strikeLabel && rawStrikeConfig) {
      try {
        var strikeConfig = JSON.parse(rawStrikeConfig);
        var strikeText = getStrikeArchetypeFromConfig(strikeConfig);
        strikeLabel.textContent = strikeText;
        autoSizeArchetypeText(strikeLabel, strikeText);
      } catch (error) {
        strikeLabel.textContent = 'Strike';
        autoSizeArchetypeText(strikeLabel, 'Strike');
      }
    }

    window.setTimeout(function () {
      primaryStrikeBadge.classList.add('is-intro');
    }, 380);
  }
}
function autoSizeArchetypeText(el, text) {
  if (!el) return;

  var length = (text || '').length;

  if (length <= 6) {
    el.style.fontSize = '17px';
  } else if (length <= 8) {
    el.style.fontSize = '15.5px';
  } else if (length <= 10) {
    el.style.fontSize = '14px';
  } else {
    el.style.fontSize = '13px';
  }
}

function showCompareBadge(compareItem) {
  var compareBehaviorBadge = document.querySelector('[data-archetype-compare-behavior]');
  var compareStrikeBadge = document.querySelector('[data-archetype-compare-strike]');
  var comparePositioningBadge = document.querySelector('[data-archetype-compare-positioning]');
  var compareFightBadge = document.querySelector('[data-archetype-compare-fight]');

  var primaryBehaviorBadge = document.querySelector('[data-archetype-primary-behavior]');
  var primaryStrikeBadge = document.querySelector('[data-archetype-primary-strike]');
  var primaryPositioningBadge = document.querySelector('[data-archetype-primary-positioning]');
  var primaryFightBadge = document.querySelector('[data-archetype-primary-fight]');

  if (compareBehaviorBadge) {
    var behaviorLabel = compareBehaviorBadge.querySelector('.species-archetypeBadge__label');
    var behaviorSpecies = compareBehaviorBadge.querySelector('[data-archetype-compare-behavior-species]');

    if (behaviorLabel) {
      var behaviorText = getBehaviorArchetypeFromAxes((compareItem && compareItem.behavior && compareItem.behavior.axes) || []);
      behaviorLabel.textContent = behaviorText;
      autoSizeArchetypeText(behaviorLabel, behaviorText);
    }

    if (behaviorSpecies) {
      behaviorSpecies.textContent = (compareItem && compareItem.title) || '';
    }

    compareBehaviorBadge.hidden = false;
    compareBehaviorBadge.classList.add('is-visible');
    compareBehaviorBadge.classList.remove('is-entering');
    void compareBehaviorBadge.offsetWidth;
    compareBehaviorBadge.classList.add('is-entering');
  }

  if (compareStrikeBadge) {
    var strikeLabel = compareStrikeBadge.querySelector('.species-archetypeBadge__label');
    var strikeSpecies = compareStrikeBadge.querySelector('[data-archetype-compare-strike-species]');

    if (strikeLabel) {
      var strikeText = getStrikeArchetypeFromAxes((compareItem && compareItem.strike && compareItem.strike.axes) || []);
      strikeLabel.textContent = strikeText;
      autoSizeArchetypeText(strikeLabel, strikeText);
    }

    if (strikeSpecies) {
      strikeSpecies.textContent = (compareItem && compareItem.title) || '';
    }

    compareStrikeBadge.hidden = false;
    compareStrikeBadge.classList.add('is-visible');
    compareStrikeBadge.classList.remove('is-entering');
    void compareStrikeBadge.offsetWidth;
    compareStrikeBadge.classList.add('is-entering');
  }

    if (comparePositioningBadge) {
    var positioningLabel = comparePositioningBadge.querySelector('.species-archetypeBadge__label');
    var positioningSpecies = comparePositioningBadge.querySelector('[data-archetype-compare-positioning-species]');

    if (positioningLabel) {
      var positioningText = getPositioningArchetypeFromAxes((compareItem && compareItem.habitat && compareItem.habitat.axes) || []);
      positioningLabel.textContent = positioningText;
      autoSizeArchetypeText(positioningLabel, positioningText);
    }

    if (positioningSpecies) {
      positioningSpecies.textContent = (compareItem && compareItem.title) || '';
    }

    comparePositioningBadge.hidden = false;
    comparePositioningBadge.classList.add('is-visible');
    comparePositioningBadge.classList.remove('is-entering');
    void comparePositioningBadge.offsetWidth;
    comparePositioningBadge.classList.add('is-entering');
  }

  if (compareFightBadge) {
    var fightLabel = compareFightBadge.querySelector('.species-archetypeBadge__label');
    var fightSpecies = compareFightBadge.querySelector('[data-archetype-compare-fight-species]');

    if (fightLabel) {
      var fightText = getFightArchetypeFromAxes((compareItem && compareItem.fight && compareItem.fight.axes) || []);
      fightLabel.textContent = fightText;
      autoSizeArchetypeText(fightLabel, fightText);
    }

    if (fightSpecies) {
      fightSpecies.textContent = (compareItem && compareItem.title) || '';
    }

    compareFightBadge.hidden = false;
    compareFightBadge.classList.add('is-visible');
    compareFightBadge.classList.remove('is-entering');
    void compareFightBadge.offsetWidth;
    compareFightBadge.classList.add('is-entering');
  }

  [primaryBehaviorBadge, primaryStrikeBadge, primaryPositioningBadge, primaryFightBadge].forEach(function (badge) {
    if (!badge) return;
    badge.classList.remove('is-intro');
    void badge.offsetWidth;
    badge.classList.add('is-intro');
  });
}

function hideCompareBadge() {
  var badges = document.querySelectorAll('[data-archetype-compare-behavior], [data-archetype-compare-strike], [data-archetype-compare-positioning], [data-archetype-compare-fight]');

  badges.forEach(function (compareBadge) {
    compareBadge.classList.remove('is-visible', 'is-entering');

    window.setTimeout(function () {
      if (!compareBadge.classList.contains('is-visible')) {
        compareBadge.hidden = true;
      }
    }, 280);
  });
}

var TOP_FISHERIES_GEOCODE_DELAY_MS = 1100;
var topFisheriesGeocodeQueue = Promise.resolve();

function sanitizeZipCode(value) {
  return String(value || '').replace(/\D+/g, '').slice(0, 5);
}

function getTopFisheriesCache(key) {
  try {
    var raw = window.localStorage.getItem(key);
    if (!raw) return null;

    var parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;

    if (parsed.expiresAt && Date.now() > parsed.expiresAt) {
      window.localStorage.removeItem(key);
      return null;
    }

    return parsed.value;
  } catch (error) {
    return null;
  }
}

function setTopFisheriesCache(key, value, ttlMs) {
  try {
    window.localStorage.setItem(key, JSON.stringify({
      value: value,
      expiresAt: Date.now() + ttlMs
    }));
  } catch (error) {}
}

function haversineMiles(lat1, lon1, lat2, lon2) {
  var toRad = Math.PI / 180;
  var dLat = (lat2 - lat1) * toRad;
  var dLon = (lon2 - lon1) * toRad;

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return 3958.8 * c;
}

function lookupZipCoords(zip) {
  var cleanZip = sanitizeZipCode(zip);
  if (cleanZip.length !== 5) {
    return Promise.reject(new Error('invalid_zip'));
  }

  var cacheKey = 'fishyaf_zip_' + cleanZip;
  var cached = getTopFisheriesCache(cacheKey);
  if (cached) return Promise.resolve(cached);

  return fetch('https://api.zippopotam.us/us/' + encodeURIComponent(cleanZip), {
    method: 'GET'
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error('zip_lookup_failed');
      }
      return response.json();
    })
    .then(function (data) {
      var place = data && data.places && data.places[0];
      if (!place) {
        throw new Error('zip_lookup_failed');
      }

      var result = {
        zip: cleanZip,
        lat: parseFloat(place.latitude),
        lon: parseFloat(place.longitude),
        city: place['place name'] || '',
        state: place.state || place['state abbreviation'] || ''
      };

      if (isNaN(result.lat) || isNaN(result.lon)) {
        throw new Error('zip_lookup_failed');
      }

      setTopFisheriesCache(cacheKey, result, 1000 * 60 * 60 * 24 * 30);
      return result;
    });
}

function geocodeFisheryQuery(query) {
  var normalized = String(query || '').trim();
  if (!normalized) {
    return Promise.resolve(null);
  }

  var cacheKey = 'fishyaf_fishery_' + normalized.toLowerCase();
  var cached = getTopFisheriesCache(cacheKey);
  if (cached) return Promise.resolve(cached);

  topFisheriesGeocodeQueue = topFisheriesGeocodeQueue
    .catch(function () {})
    .then(function () {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, TOP_FISHERIES_GEOCODE_DELAY_MS);
      });
    })
    .then(function () {
      var endpoint =
        'https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&q=' +
        encodeURIComponent(normalized);

      return fetch(endpoint, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (results) {
          if (!results || !results.length) {
            setTopFisheriesCache(cacheKey, null, 1000 * 60 * 60 * 24 * 7);
            return null;
          }

          var item = results[0];
          var payload = {
            lat: parseFloat(item.lat),
            lon: parseFloat(item.lon),
            display_name: item.display_name || normalized
          };

          if (isNaN(payload.lat) || isNaN(payload.lon)) {
            setTopFisheriesCache(cacheKey, null, 1000 * 60 * 60 * 24 * 7);
            return null;
          }

          setTopFisheriesCache(cacheKey, payload, 1000 * 60 * 60 * 24 * 30);
          return payload;
        })
        .catch(function () {
          return null;
        });
    });

  return topFisheriesGeocodeQueue;
}

function setTopFisheriesStatus(root, text, tone) {
  if (!root) return;
  var label = root.querySelector('[data-top-fisheries-status]');
  if (!label) return;

  label.textContent = text || '';
  label.classList.remove('is-error', 'is-success', 'is-loading');

  if (tone) {
    label.classList.add('is-' + tone);
  }
}

function resetTopFisheriesCards(root) {
  if (!root) return;

  var strip = root.querySelector('[data-top-fisheries-strip]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fishery-card]'));

  cards.forEach(function (card) {
    card.classList.remove('is-closest', 'is-unknown', 'is-updating');

    var distanceValue = card.querySelector('[data-fishery-distance-value]');
    var distanceMode = card.querySelector('[data-fishery-distance-mode]');
    var distanceLabel = card.querySelector('.species-topFisheries__distanceLabel');

    if (distanceValue) {
  distanceValue.textContent = '';
}

if (distanceLabel) {
  distanceLabel.textContent = 'Enter ZIP Above';
}

if (distanceMode) {
  distanceMode.innerHTML = '';
}

    card.removeAttribute('data-distance-miles');
  });

  cards.forEach(function (card) {
    if (strip) strip.appendChild(card);
  });
}

function pulseTopFisheriesCard(card) {
  if (!card) return;

  card.classList.remove('is-updating');
  void card.offsetWidth;
  card.classList.add('is-updating');

  window.setTimeout(function () {
    card.classList.remove('is-updating');
  }, 420);
}

function applyTopFisheriesDistances(root, zipData, cardResults) {
  if (!root) return;

  var strip = root.querySelector('[data-top-fisheries-strip]');
  if (!strip) return;

  var sortable = cardResults.slice().sort(function (a, b) {
    if (a.distanceMiles == null && b.distanceMiles == null) return 0;
    if (a.distanceMiles == null) return 1;
    if (b.distanceMiles == null) return -1;
    return a.distanceMiles - b.distanceMiles;
  });

  sortable.forEach(function (result, index) {
    var card = result.card;
    var distanceValue = card.querySelector('[data-fishery-distance-value]');
    var distanceMode = card.querySelector('[data-fishery-distance-mode]');
    var distanceLabel = card.querySelector('.species-topFisheries__distanceLabel');

    card.classList.remove('is-closest', 'is-unknown');

    if (result.distanceMiles == null) {
  card.classList.add('is-unknown');

  if (distanceValue) distanceValue.textContent = '?';
  if (distanceLabel) distanceLabel.textContent = 'Distance Unknown';
  if (distanceMode) distanceMode.textContent = '';

      card.removeAttribute('data-distance-miles');
    } else {
      var rounded = Math.round(result.distanceMiles);

      if (index === 0) {
        card.classList.add('is-closest');
      }

      if (distanceValue) {
        animateFisheryDistance(distanceValue, rounded);
      }

      if (distanceLabel) {
        distanceLabel.textContent = 'Miles';
      }

      if (distanceMode) {
        distanceMode.innerHTML = getTravelModeMarkup(rounded);
      }

      card.setAttribute('data-distance-miles', String(rounded));
    }

    strip.appendChild(card);
    pulseTopFisheriesCard(card);
  });
}

function runTopFisheriesLookup(root, zip) {
  var cleanZip = sanitizeZipCode(zip);
  if (cleanZip.length !== 5) {
    resetTopFisheriesCards(root);
    setTopFisheriesStatus(root, 'Enter a valid 5-digit ZIP code', 'error');
    return;
  }

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-fishery-card]'));
  if (!cards.length) return;

  setTopFisheriesStatus(root, 'Looking up distances...', 'loading');

  lookupZipCoords(cleanZip)
    .then(function (zipData) {
      var jobs = cards.map(function (card) {
        var query = card.getAttribute('data-location-query') || '';
        return geocodeFisheryQuery(query).then(function (fisheryCoords) {
          var distanceMiles = null;

          if (fisheryCoords && typeof fisheryCoords.lat === 'number' && typeof fisheryCoords.lon === 'number') {
            distanceMiles = haversineMiles(
              zipData.lat,
              zipData.lon,
              fisheryCoords.lat,
              fisheryCoords.lon
            );
          }

          return {
            card: card,
            distanceMiles: distanceMiles
          };
        });
      });

      return Promise.all(jobs).then(function (results) {
        applyTopFisheriesDistances(root, zipData, results);
        setTopFisheriesStatus(root, 'Approximate straight-line distance from ' + zipData.zip, 'success');
      });
    })
    .catch(function () {
      resetTopFisheriesCards(root);
      setTopFisheriesStatus(root, 'ZIP lookup failed. Try another ZIP.', 'error');
    });
}

function getTravelModeMarkup(distanceMiles) {
  if (distanceMiles == null || isNaN(distanceMiles)) {
    return '';
  }

  var src = '';

  if (distanceMiles < 5) {
    src = 'https://cdn.shopify.com/s/files/1/0360/2880/9260/files/WALKING.png?v=1775065624';
  } else if (distanceMiles < 10) {
    src = 'https://cdn.shopify.com/s/files/1/0360/2880/9260/files/BIKE.png?v=1775065327';
  } else if (distanceMiles < 250) {
    src = 'https://cdn.shopify.com/s/files/1/0360/2880/9260/files/TRUCK.png?v=1775064069';
  } else {
    src = 'https://cdn.shopify.com/s/files/1/0360/2880/9260/files/JET.png?v=1775064902';
  }

  return '<img src="' + src + '" alt="" class="species-topFisheries__modeIcon" loading="lazy" decoding="async">';
}

function animateFisheryDistance(el, targetValue) {
  if (!el) return;

  var finalValue = Math.max(0, Math.round(targetValue || 0));
  var duration = 850;
  var startTime = null;

  el.textContent = '0';

  function step(timestamp) {
    if (!startTime) startTime = timestamp;

    var progress = Math.min((timestamp - startTime) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var current = Math.round(finalValue * eased);

    el.textContent = String(current);

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      el.textContent = String(finalValue);
    }
  }

  window.requestAnimationFrame(step);
}

function initTrophyMeter() {
  var roots = document.querySelectorAll('[data-species-trophy-meter]');
  if (!roots.length) return;

  function clampTrophy(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function roundSmart(value) {
    if (value == null || isNaN(value)) return 0;
    if (value >= 100) return Math.round(value);
    if (value >= 10) return Math.round(value * 10) / 10;
    return Math.round(value * 100) / 100;
  }

  function formatNumber(value) {
    var rounded = roundSmart(value);
    if (Math.abs(rounded % 1) < 0.001) {
      return String(Math.round(rounded));
    }
    return String(rounded);
  }

  function parseRangeMax(text, unitPatterns) {
    var source = String(text || '').toLowerCase().replace(/,/g, '');
    var max = null;

    unitPatterns.forEach(function (pattern) {
      var regex = new RegExp('(\\d+(?:\\.\\d+)?)\\s*(?:[-–—to]+\\s*(\\d+(?:\\.\\d+)?))?\\s*' + pattern, 'gi');
      var match;

      while ((match = regex.exec(source))) {
        var first = parseFloat(match[1] || '0');
        var second = parseFloat(match[2] || '0');
        var candidate = second || first;
        if (!isNaN(candidate)) {
          max = max == null ? candidate : Math.max(max, candidate);
        }
      }
    });

    return max;
  }

  function parseWorldRecordWeight(text) {
    var source = String(text || '').toLowerCase().replace(/,/g, ' ');
    var pounds = 0;
    var ounces = 0;
    var found = false;

    var lbMatch = source.match(/(\d+(?:\.\d+)?)\s*(?:lb|lbs|pound|pounds)\b/);
    if (lbMatch) {
      pounds = parseFloat(lbMatch[1] || '0') || 0;
      found = true;
    }

    var ozMatch = source.match(/(\d+(?:\.\d+)?)\s*(?:oz|ounce|ounces)\b/);
    if (ozMatch) {
      ounces = parseFloat(ozMatch[1] || '0') || 0;
      found = true;
    }

    var kgMatch = source.match(/(\d+(?:\.\d+)?)\s*kg\b/);
    if (!found && kgMatch) {
      return (parseFloat(kgMatch[1] || '0') || 0) * 2.20462;
    }

    return found ? pounds + (ounces / 16) : null;
  }

  function parseWorldRecordLength(text) {
    var source = String(text || '').toLowerCase();

    source = source.replace(/\b(18|19|20)\d{2}\b/g, '');

    var match = source.match(/(\d+(?:\.\d+)?)\s*(?:inch|inches|in\b|")/);
    if (match) {
      return parseFloat(match[1]);
    }

    return null;
  }

 function formatInches(value, approximate) {
  if (value == null || isNaN(value)) return '';
  return formatNumber(value) + '"';
}

function formatPounds(value, approximate) {
  if (value == null || isNaN(value)) return '';
  return formatNumber(value) + ' lbs';
}

  function formatTierNumber(value, type, approximate) {
    return type === 'length' ? formatInches(value, approximate) : formatPounds(value, approximate);
  }

  function getDisplayCeiling(value, type) {
  if (value == null || isNaN(value) || value <= 0) return value;

  if (type === 'length') {
    if (value <= 20) return Math.ceil(value / 5) * 5;
    if (value <= 60) return Math.ceil(value / 10) * 10;
    if (value <= 120) return Math.ceil(value / 20) * 20;
    return Math.ceil(value / 25) * 25;
  }

  if (type === 'weight') {
    if (value <= 10) return Math.ceil(value / 2) * 2;
    if (value <= 25) return Math.ceil(value / 5) * 5;
    if (value <= 100) return Math.ceil(value / 10) * 10;
    if (value <= 250) return Math.ceil(value / 25) * 25;
    if (value <= 500) return Math.ceil(value / 50) * 50;
    return Math.ceil(value / 100) * 100;
  }

  return value;
}

function buildThresholds(avgValue, maxValue) {
  if (avgValue == null || maxValue == null || avgValue <= 0 || maxValue <= 0) return null;

  var A = avgValue;
  var M = maxValue;

  var unicornStart = M * 0.90;

  var t0 = 0;
  var t1 = Math.min(A * 0.50, M * 0.22);
  var t2 = Math.min(A * 0.80, M * 0.36);
  var t3 = Math.min(A * 1.20, M * 0.52);
  var t4 = Math.min(A * 1.50, M * 0.66);
  var t5 = Math.min(A * 1.90, M * 0.82);
  var t6 = unicornStart;
  var t7 = M;

  var points = [t0, t1, t2, t3, t4, t5, t6, t7].map(function (value) {
    return clampTrophy(value, 0, M);
  });

  for (var i = 1; i < points.length; i++) {
    if (points[i] < points[i - 1]) {
      points[i] = points[i - 1];
    }
  }

  return {
    small:   [points[0], points[1]],
    common:  [points[1], points[2]],
    average: [points[2], points[3]],
    nice:    [points[3], points[4]],
    sick:    [points[4], points[5]],
    trophy:  [points[5], points[6]],
    unicorn: [points[6], points[7]]
  };
}

  function buildTierObjects(avgValue, maxValue) {
    var thresholds = buildThresholds(avgValue, maxValue);
    if (!thresholds) return [];

    return [
      { key: 'small', label: 'Small', start: thresholds.small[0], end: thresholds.small[1], className: 'small' },
      { key: 'common', label: 'Common', start: thresholds.common[0], end: thresholds.common[1], className: 'common' },
      { key: 'average', label: 'Average', start: thresholds.average[0], end: thresholds.average[1], className: 'average' },
      { key: 'nice', label: 'Nice Fish', start: thresholds.nice[0], end: thresholds.nice[1], className: 'nice' },
      { key: 'sick', label: 'Sick', start: thresholds.sick[0], end: thresholds.sick[1], className: 'sick' },
      { key: 'trophy', label: 'Trophy', start: thresholds.trophy[0], end: thresholds.trophy[1], className: 'trophy' },
      { key: 'unicorn', label: 'God-Damned Unicorn', start: thresholds.unicorn[0], end: thresholds.unicorn[1], className: 'unicorn' }
    ];
  }

  function formatRange(start, end, type, isLast) {
    if (type === 'length') {
      if (isLast) return formatNumber(start) + '"+';
      return formatNumber(start) + '–' + formatNumber(end) + '"';
    }

    if (isLast) return formatNumber(start) + '+ lbs';
    return formatNumber(start) + '–' + formatNumber(end) + ' lbs';
  }

  function renderBands(trackEl, tierData, maxValue) {
  if (!trackEl) return;
  trackEl.innerHTML = '';

  tierData.forEach(function (tier) {
    var startPct = maxValue > 0 ? (tier.start / maxValue) * 100 : 0;
    var endPct = maxValue > 0 ? (tier.end / maxValue) * 100 : 0;
    var widthPct = Math.max(0.5, endPct - startPct);

    var band = document.createElement('div');
    band.className = 'species-trophyMeter__band species-trophyMeter__band--' + tier.className;
    band.setAttribute('data-tier-key', tier.key);
    band.style.left = startPct + '%';
    band.style.width = widthPct + '%';
    trackEl.appendChild(band);
  });
}

  function renderTierLabels(tiersEl, tierData, type) {
    if (!tiersEl) return;
    tiersEl.innerHTML = '';

    tierData.forEach(function (tier, index) {
      var item = document.createElement('div');
      item.className = 'species-trophyMeter__tier species-trophyMeter__tier--' + tier.className;

      var label = document.createElement('div');
      label.className = 'species-trophyMeter__tierLabel';
      label.textContent = tier.label;

      var range = document.createElement('div');
      range.className = 'species-trophyMeter__tierRange';
      range.textContent = formatRange(tier.start, tier.end, type, index === tierData.length - 1);

      item.appendChild(label);
      item.appendChild(range);
      tiersEl.appendChild(item);
    });
  }
function updateLiveDisplay(root, type, value, category) {
  var handleText = root.querySelector('[data-trophy-handle-text="' + type + '"]');
  var categoryEl = root.querySelector('[data-trophy-result-category="' + type + '"]');
  var resultPill = root.querySelector('[data-trophy-result="' + type + '"]');

  if (!handleText || !categoryEl || !resultPill) return;

  var formatted = type === 'length'
    ? formatInches(value, false)
    : formatPounds(value, false);

  handleText.textContent = formatted;
  categoryEl.textContent = category;

  resultPill.classList.remove(
    'species-trophyMeter__resultPill--small',
    'species-trophyMeter__resultPill--common',
    'species-trophyMeter__resultPill--average',
    'species-trophyMeter__resultPill--nice',
    'species-trophyMeter__resultPill--sick',
    'species-trophyMeter__resultPill--trophy',
    'species-trophyMeter__resultPill--unicorn'
  );

  var categoryClass = 'small';
  if (category === 'Common') categoryClass = 'common';
  else if (category === 'Average') categoryClass = 'average';
  else if (category === 'Nice Fish') categoryClass = 'nice';
  else if (category === 'Sick') categoryClass = 'sick';
  else if (category === 'Trophy') categoryClass = 'trophy';
  else if (category === 'God-Damned Unicorn') categoryClass = 'unicorn';

  resultPill.classList.add('species-trophyMeter__resultPill--' + categoryClass);
}
function initSlider(root, type, avgValue, maxValue, tierData) {
  var track = root.querySelector('[data-trophy-track="' + type + '"]');
  var handle = root.querySelector('[data-trophy-handle="' + type + '"]');
  var fill = root.querySelector('[data-trophy-fill="' + type + '"]');

  if (!track || !handle || !maxValue) return;

  var dragging = false;

  function setActiveBand(category) {
    var bands = track.querySelectorAll('.species-trophyMeter__band');
    bands.forEach(function (band) {
      band.classList.remove('species-trophyMeter__band--active');
    });

    var activeKey = 'small';
    if (category === 'Common') activeKey = 'common';
    else if (category === 'Average') activeKey = 'average';
    else if (category === 'Nice Fish') activeKey = 'nice';
    else if (category === 'Sick') activeKey = 'sick';
    else if (category === 'Trophy') activeKey = 'trophy';
    else if (category === 'God-Damned Unicorn') activeKey = 'unicorn';

    var activeBand = track.querySelector('[data-tier-key="' + activeKey + '"]');
    if (activeBand) activeBand.classList.add('species-trophyMeter__band--active');
  }

  function updateFromRatio(ratio) {
    ratio = clampTrophy(ratio, 0, 1);
    var value = ratio * maxValue;

    handle.style.left = (ratio * 100) + '%';
    if (fill) fill.style.width = (ratio * 100) + '%';

    var category = '';
    tierData.forEach(function (tier) {
      if (value >= tier.start && value <= tier.end) {
        category = tier.label;
      }
    });

    if (!category && tierData.length) {
      if (value <= tierData[0].end) {
        category = tierData[0].label;
      } else {
        category = tierData[tierData.length - 1].label;
      }
    }

    updateLiveDisplay(root, type, value, category);
    setActiveBand(category);
  }

  function updateFromX(clientX) {
    var rect = track.getBoundingClientRect();
    var x = clampTrophy(clientX - rect.left, 0, rect.width);
    var ratio = rect.width ? (x / rect.width) : 0;
    updateFromRatio(ratio);
  }

 track.addEventListener('mousedown', function (e) {
  dragging = true;
  handle.classList.add('is-engaged');
  updateFromX(e.clientX);
});

  document.addEventListener('mousemove', function (e) {
    if (!dragging) return;
    updateFromX(e.clientX);
  });

  document.addEventListener('mouseup', function () {
    dragging = false;
    handle.classList.remove('is-engaged');
  });

  track.addEventListener('touchstart', function (e) {
  if (!e.touches || !e.touches.length) return;
  handle.classList.add('is-engaged');
  updateFromX(e.touches[0].clientX);
}, { passive: true });

  track.addEventListener('touchmove', function (e) {
    if (!e.touches || !e.touches.length) return;
    updateFromX(e.touches[0].clientX);
  }, { passive: true });

  track.addEventListener('touchend', function () {
    handle.classList.remove('is-engaged');
  });

  var avgRatio = avgValue && maxValue ? (avgValue / maxValue) : 0.5;
  updateFromRatio(avgRatio);
}

  function buildLede(speciesName, avgLenMin, avgLenMax, avgWtMin, avgWtMax, wrWeight, hasAnyRecord, derivedLengthMax, derivedWeightMax) {
    var parts = [];
    var subject = speciesName || 'This species';

    if (avgLenMax != null && avgWtMax != null) {
      parts.push(subject + ' commonly run about ' + formatNumber(avgLenMin || avgLenMax) + '–' + formatNumber(avgLenMax) + ' inches and ' + formatNumber(avgWtMin || avgWtMax) + '–' + formatNumber(avgWtMax) + ' pounds.');
    } else if (avgLenMax != null) {
      parts.push(subject + ' commonly reach about ' + formatNumber(avgLenMin || avgLenMax) + '–' + formatNumber(avgLenMax) + ' inches.');
    } else if (avgWtMax != null) {
      parts.push(subject + ' commonly run about ' + formatNumber(avgWtMin || avgWtMax) + '–' + formatNumber(avgWtMax) + ' pounds.');
    }

    if (hasAnyRecord && wrWeight != null) {
      parts.push('The current benchmark reaches ' + formatPounds(wrWeight, false) + '.');
    } else if (!hasAnyRecord && (derivedLengthMax != null || derivedWeightMax != null)) {
      parts.push('No official world record data is listed here, so the upper benchmark uses estimated max size based on known averages.');
    }

    parts.push('The bar below shows the full scale from zero to peak size, with color bands showing what counts as common, trophy, and near-record territory.');
    return parts.join(' ');
  }

  function buildCommonCatchText(avgWtMin, avgWtMax) {
  if (avgWtMin != null && avgWtMax != null) {
    return formatPounds(avgWtMin, false) + '–' + formatPounds(avgWtMax, false);
  }

  if (avgWtMax != null) {
    var low = roundSmart(avgWtMax * 0.6);
    return formatPounds(low, false) + '–' + formatPounds(avgWtMax, false);
  }

  return '';
}

function buildTrophyWeightText(weightAvg, weightMax) {
  if (weightAvg == null || weightMax == null) return '';
  var weightTrophy = Math.min(weightAvg * 1.9, weightMax * 0.90);
  return formatPounds(weightTrophy, false) + '+';
}

function buildWorldRecordText(wrWeight, weightMax) {
  if (wrWeight != null) return formatPounds(wrWeight, false);
  if (weightMax != null) return formatPounds(weightMax, false);
  return '';
}

function updateBenchmarkPills(root, avgWtMin, avgWtMax, wrWeight, weightMax) {
  var wrap = root.querySelector('[data-trophy-benchmark-pills]');
  var commonEl = root.querySelector('[data-trophy-pill-common]');
  var trophyEl = root.querySelector('[data-trophy-pill-trophy]');
  var recordEl = root.querySelector('[data-trophy-pill-record]');

  if (!wrap || !commonEl || !trophyEl || !recordEl) return;

  var commonText = buildCommonCatchText(avgWtMin, avgWtMax);
  var trophyText = buildTrophyWeightText(avgWtMax, weightMax);
  var recordText = buildWorldRecordText(wrWeight, weightMax);

  commonEl.textContent = commonText || '—';
  trophyEl.textContent = trophyText || '—';
  recordEl.textContent = recordText || '—';

  wrap.hidden = false;
}

  function buildThresholdText(speciesName, weightAvg, weightMax, lengthAvg, lengthMax) {
    var chunks = [];

    if (weightAvg != null && weightMax != null) {
      var weightTrophy = Math.min(weightAvg * 1.9, weightMax * 0.90);
      chunks.push(formatPounds(weightTrophy, false));
    }

    if (lengthAvg != null && lengthMax != null) {
      var lengthTrophy = Math.min(lengthAvg * 1.9, lengthMax * 0.90);
      chunks.push(formatInches(lengthTrophy, false));
    }

    if (!chunks.length) return '';
    return 'Trophy ' + speciesName + ' starts around ' + chunks.join(' or ');
  }

  function positionTrophyMarker(root, type, actualMaxValue, displayCeiling) {
  var marker = root.querySelector('[data-trophy-marker="' + type + '"]');
  if (!marker || !actualMaxValue || !displayCeiling) return;

  var ratio = clampTrophy(actualMaxValue / displayCeiling, 0, 1);
  marker.style.left = (ratio * 100) + '%';
}

  function renderMetric(root, type, avgValue, maxValue, maxLabel, approximateMax) {
  if (avgValue == null || maxValue == null || maxValue <= 0) return;

  var displayCeiling = getDisplayCeiling(maxValue, type);

  if (type === 'length' && avgValue && maxValue && maxValue > avgValue * 3) {
    return;
  }

  var card = root.querySelector('[data-trophy-meter-card="' + type + '"]');
  var bands = root.querySelector('[data-trophy-bands="' + type + '"]');
  var tiers = root.querySelector('[data-trophy-tiers="' + type + '"]');
  var axisEndEls = root.querySelectorAll('[data-trophy-axis-end="' + type + '"]');

  if (!card || !bands) return;

  var thresholds = buildThresholds(avgValue, displayCeiling);
  if (!thresholds) return;

  var tierData = [
    { key: 'small', label: 'Small', className: 'small', start: thresholds.small[0], end: thresholds.small[1] },
    { key: 'common', label: 'Common', className: 'common', start: thresholds.common[0], end: thresholds.common[1] },
    { key: 'average', label: 'Average', className: 'average', start: thresholds.average[0], end: thresholds.average[1] },
    { key: 'nice', label: 'Nice Fish', className: 'nice', start: thresholds.nice[0], end: thresholds.nice[1] },
    { key: 'sick', label: 'Sick', className: 'sick', start: thresholds.sick[0], end: thresholds.sick[1] },
    { key: 'trophy', label: 'Trophy', className: 'trophy', start: thresholds.trophy[0], end: thresholds.trophy[1] },
    { key: 'unicorn', label: 'God-Damned Unicorn', className: 'unicorn', start: thresholds.unicorn[0], end: thresholds.unicorn[1] }
  ];

  axisEndEls.forEach(function(el){
  if (type === 'length') {
    el.textContent = 'Up to ' + formatInches(displayCeiling, false);
  } else {
    el.textContent = 'Up to ' + formatPounds(displayCeiling, false);
  }
});

  renderBands(bands, tierData, displayCeiling);
if (tiers) renderTierLabels(tiers, tierData, type);
positionTrophyMarker(root, type, maxValue, displayCeiling);
initSlider(root, type, avgValue, displayCeiling, tierData);

  card.hidden = false;
}

  roots.forEach(function (root) {
    if (root.getAttribute('data-trophy-meter-ready') === 'true') return;

    var speciesName = root.getAttribute('data-species-name') || '';
    var averageText = root.getAttribute('data-average-size') || '';
    var wrShort = root.getAttribute('data-world-record-short') || '';
    var wrLong = root.getAttribute('data-world-record-long') || '';
    var wrText = wrLong || wrShort;

    var avgLenMin = null;
    var avgLenMax = parseRangeMax(averageText, ['(?:inch|inches|in\\b|")']);
    var avgWtMax = parseRangeMax(averageText, ['(?:lb|lbs|pound|pounds)']);
    var avgWtMin = null;

    var wtRangeMatch = String(averageText).toLowerCase().match(/(\d+(?:\.\d+)?)\s*(?:[-–—to]+)\s*(\d+(?:\.\d+)?)\s*(?:lb|lbs|pound|pounds)/);
    if (wtRangeMatch) {
      avgWtMin = parseFloat(wtRangeMatch[1] || '0') || null;
      avgWtMax = parseFloat(wtRangeMatch[2] || '0') || avgWtMax;
    }

    var lenRangeMatch = String(averageText).toLowerCase().match(/(\d+(?:\.\d+)?)\s*(?:[-–—to]+)\s*(\d+(?:\.\d+)?)\s*(?:inch|inches|in\b|")/);
    if (lenRangeMatch) {
      avgLenMin = parseFloat(lenRangeMatch[1] || '0') || null;
      avgLenMax = parseFloat(lenRangeMatch[2] || '0') || avgLenMax;
    }

    var wrWeight = parseWorldRecordWeight(wrText);
    var wrLength = parseWorldRecordLength(wrText);

    var hasAnyRecord = !!String(wrText).trim();
    var derivedWeightMax = null;
    var derivedLengthMax = null;

    if (wrWeight == null && avgWtMax != null) {
      derivedWeightMax = roundSmart(avgWtMax * 1.75);
    }

    if (wrLength == null && avgLenMax != null) {
      derivedLengthMax = roundSmart(avgLenMax * 1.75);
    }

    var weightMax = wrWeight != null ? wrWeight : derivedWeightMax;
    var lengthMax = wrLength != null ? wrLength : derivedLengthMax;

    renderMetric(root, 'length', avgLenMax, lengthMax, wrLength != null ? 'World Record' : 'Max Size', wrLength == null);
    renderMetric(root, 'weight', avgWtMax, weightMax, wrWeight != null ? 'World Record' : 'Max Size', wrWeight == null);

    updateBenchmarkPills(root, avgWtMin, avgWtMax, wrWeight, weightMax);

var lede = root.querySelector('[data-trophy-meter-lede]');
if (lede) {
  lede.hidden = true;
}

var thresholdEl = root.querySelector('[data-trophy-meter-threshold]');
if (thresholdEl) {
  thresholdEl.hidden = true;
  thresholdEl.textContent = '';
}

var footer = root.querySelector('[data-trophy-meter-footer]');
if (footer) {
  footer.hidden = true;
  footer.textContent = '';
}

root.setAttribute('data-trophy-meter-ready', 'true');
  });
}

function initTopFisheriesDistance() {
  var roots = document.querySelectorAll('[data-top-fisheries]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    if (root.getAttribute('data-top-fisheries-ready') === 'true') return;

    var input = root.querySelector('[data-top-fisheries-zip]');
    if (!input) return;

    var debounceId = null;
    resetTopFisheriesCards(root);
setTopFisheriesStatus(root, 'Enter your ZIP for approximate distance', '');

    function handleLookup() {
      var cleanZip = sanitizeZipCode(input.value);
      input.value = cleanZip;

      if (!cleanZip) {
        resetTopFisheriesCards(root);
        setTopFisheriesStatus(root, 'Enter your ZIP for approximate distance', '');
        return;
      }

      if (cleanZip.length < 5) {
        setTopFisheriesStatus(root, 'Enter a valid 5-digit ZIP code', 'error');
        return;
      }

      runTopFisheriesLookup(root, cleanZip);
    }

    input.addEventListener('input', function () {
      input.value = sanitizeZipCode(input.value);

      if (debounceId) {
        window.clearTimeout(debounceId);
      }

      debounceId = window.setTimeout(handleLookup, 350);
    });

    input.addEventListener('blur', handleLookup);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleLookup();
      }
    });

    root.setAttribute('data-top-fisheries-ready', 'true');
  });
}

    initMedallion();
  initFishyafFacts();
  formatFaqAnswers();
  initCollapsibles();
  initFaqAccordion();
  initRandomSpeciesButtons();
  wrapFirstSpeciesNameInOverview();
  initRelatedSpeciesScoreHover();
  initFishingWindowReveal();
  initDifficultyMeterReveal();
  initFeedingTriggersReveal();
  initBehaviorRadars();
  initSpeciesComparisonSelector();
  initArchetypeBadges();
  initRadarTooltips();
  initTrophyMeter();
  initTopFisheriesDistance();
  initVoiceSelector();

  function initTopSectionSwitch() {
    var switchers = document.querySelectorAll('[data-species-top-switch]');
    if (!switchers.length) return;

    switchers.forEach(function (switcher) {
      var tabs = Array.prototype.slice.call(
        switcher.querySelectorAll('[data-species-tab]')
      );
      var panels = Array.prototype.slice.call(
        switcher.querySelectorAll('[data-species-panel]')
      );

      if (!tabs.length || !panels.length) return;

      function activateTab(key) {
        tabs.forEach(function (tab) {
          var isMatch = tab.getAttribute('data-species-tab') === key;
          tab.classList.toggle('is-active', isMatch);
          tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isMatch = panel.getAttribute('data-species-panel') === key;
          panel.classList.toggle('is-active', isMatch);
          panel.hidden = !isMatch;
        });
      }

      tabs.forEach(function (tab) {
        var isDisabled =
          tab.disabled ||
          tab.getAttribute('disabled') !== null ||
          tab.getAttribute('aria-disabled') === 'true';

        if (isDisabled) return;

        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-species-tab');
          if (!key) return;
          activateTab(key);
        });
      });

      var activeTab = switcher.querySelector('[data-species-tab].is-active');
      var defaultKey = activeTab
        ? activeTab.getAttribute('data-species-tab')
        : 'facts';

      activateTab(defaultKey);
    });
  }

  initTopSectionSwitch();
  initSectionSwitchUnderline();

  window.addEventListener('resize', debounce(recheckCollapsibles, 150));

})();


